import {  AfterViewInit,  Component, TemplateRef,  ViewChild,  ElementRef} from '@angular/core';
import { NgFlowchart } from '../../../../../projects/ng-flowchart/src/lib/model/flow.model';
import { NgFlowchartStepRegistry } from '../../../../../projects/ng-flowchart/src/lib/ng-flowchart-step-registry.service';
import { NgFlowchartCanvasDirective } from '../../../../../projects/ng-flowchart/src';
import { CustomStepComponent } from './custom-step/custom-step.component';
import { RouteStepComponent } from './route-step/route-step.component';
import { FormStepComponent } from './form-step/form-step.component';
import { NestedFlowComponent } from './nested-flow/nested-flow.component';
import { FormStep1Component } from './form-step1/form-step1.component';
import { FormStep2Component } from './form-step2/form-step2.component';
import { FormStep3Component } from './form-step3/form-step3.component';
import { FormStep4Component } from './form-step4/form-step4.component';
import { TestService } from '../../../_services/test.service';
import * as _ from "lodash";
import { DropDataService } from 'projects/ng-flowchart/src/lib/services/dropdata.service';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from 'src/app/_services/setting.service';
import { HttpClient } from '@angular/common/http';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { UrlService } from 'src/app/_services/url.service';
import { ConfirmationDialogService } from '../confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProjectService } from 'src/app/_services/project.service';
import { UserMgmtService } from '../../../_services/user-mgmt.service';
import { UserService } from 'src/app/_services/user.service';
import { HomeService } from 'src/app/_services/home.service';
import * as bootstrap from 'bootstrap';
import { RedactionService } from 'src/app/_services/redaction.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'flow-chart',
  templateUrl: './flow-chart.component.html',
  styleUrls: ['./flow-chart.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowChartComponent implements AfterViewInit {
  title = 'workspace';
  stepOptions:any = undefined;
  callbacks: NgFlowchart.Callbacks = {};
  options: NgFlowchart.Options = {
    stepGap: 40,
    rootPosition: 'TOP_CENTER',
    zoom: {
      mode: 'MANUAL',
      skipRender: true,
    },
    dragScroll: ['RIGHT', 'MIDDLE'],
    orientation: 'VERTICAL',
    manualConnectors: false,
  };
  commandList: Array<any> = [];
  @ViewChild('normalStep')
  normalStepTemplate: TemplateRef<any>;
  @ViewChild("cancelCreateRC") cancelCreateRC: ElementRef;
  @ViewChild("formButton") formButton: ElementRef;

  @ViewChild("selectBox") selectBox: ElementRef;
  
  @ViewChild("selectDvDropdown") selectDvDropdown: ElementRef;
  @ViewChild("selectFunction") selectFunction: ElementRef;
  commandJson: any;
  functionJson:any;
  action: any;
  projectId: any;
  testId: any;
  url: any;

  sampleJson = {}

  items = [
    {
      name: 'Logger',
      type: 'log',
      data: {
        name: 'Log',
        icon: { name: 'log-icon', color: 'blue' },
        config: {
          message: null,
          severity: null,
        },
      },
    },
  ];

  customOps = [
    // {
    //   paletteName: 'HITL',
    //   step: {
    //     template: FormStepComponent,
    //     type: 'form-step',
    //     data: '123',
    //   },
    // },
    {
      paletteName: 'Branch',
      step: {
        template: FormStep2Component,
        type: 'form-step2',
        data: 'BranchEnable',
      },
    }
    // {
    //   paletteName: 'Process Step',
    //   step: {
    //     template: FormStep1Component,
    //     type: 'form-step',
    //     data: '123',
    //   },
    // },
    // {
    //   paletteName: 'Branch',
    //   step: {
    //     template: FormStep2Component,
    //     type: 'form-step',
    //     data: '123',
    //   },
    // },
    // {
    //   paletteName: 'End Step',
    //   step: {
    //     template: FormStep3Component,
    //     type: 'form-step',
    //     data: '123',
    //   },
    // },
    // {
    //   paletteName: 'Add',
    //   step: {
    //     template: FormStep4Component,
    //     type: 'form-step',
    //     data: '123',
    //   },
    // },
    // {
    //   paletteName: 'Nested Flow',
    //   step: {
    //     template: NestedFlowComponent,
    //     type: 'nested-flow',
    //     data: {
    //       name: 'Nested Flow',
    //     },
    //   },
    // },
  ];

  @ViewChild(NgFlowchartCanvasDirective)
  canvas: NgFlowchartCanvasDirective;

  // @Input()
  // canvas1: NgFlowchartCanvasService;
  disabled = false;
  actions: any = [];
 
  functionList: any;
  functionStep: any;
  functionData: any;
  commandSteps: any=[];
  testStepId: any;
  stepAllData: any;
  checkAllTestSteps: boolean;
  testStep: any;
  testStepCopy: any = [];
  projectType: any = 'MIXED';
  testCaseType: string;
  testStepdata: any;
  testCopyFlowChart: any;
  cardView: any;
  visibleIndexForCardTip: any;
  objectForEditTestStep: any;
  actionsMetaData: any={};
  droppedStep: any;
  subFunctionType: string;
  subFunctionObject: any;
  cookieService: any;
  // confirmationDialogService: any;
  actionType: undefined;
  stepsTobeDelete: any;
  // toastrService: any;
  loadTestStepData: boolean;
  testStepIndex: any;
  menuMobileShown: boolean;
  menuDesktopHidden: boolean;
  selectedFunction: any;
  enableTextField: boolean;
  optionSelected: any[];
  objectForEditTestStepCopy: any;
  pseCommand: any;
  actionsMetaDataCopy: any={};
  enableEdit: boolean;
  enableEditForm: boolean;
  stepTab: any;
  selectedTestCase: any;
  stepIndexTobeEdit: any;
  performedAction: string;
  groupedActionData: any;
  colors: string[];
  groupedActionDataCopy: any;
  functions: any = [];
  selectedAction: any;
  selectedValue: any;
  rawclicked: boolean = true;
  formclicked: boolean = false;
  startHighlightLocator = '';
  startHighlightRow = '';
  startHighlightColumn = '';
  menuClickLocator = '';
  menuClickPath = '';
  moveHighlightLocator = '';
  moveHighlightCurrentRow = '';
  moveHighlightCurrentColumn = '';
  moveHighlightVertical = 'NONE';
  moveHighlightVerticalCount = '1';
  moveHighlightHorizontal = 'NONE';
  moveHighlightHorizontalCount = '1';
  readonly moveHighlightVerticalOptions = [
    { value: 'NONE', label: 'No change' },
    { value: 'DOWN', label: 'Move down' },
    { value: 'UP', label: 'Move up' },
    { value: 'FIRST_ROW', label: 'Move to first row' },
    { value: 'LAST_ROW', label: 'Move to last row' }
  ];
  readonly moveHighlightHorizontalOptions = [
    { value: 'NONE', label: 'No change' },
    { value: 'FIRST_COLUMN', label: 'Move to first column' },
    { value: 'RIGHT', label: 'Move right' },
    { value: 'LEFT', label: 'Move left' },
    { value: 'LAST_COLUMN', label: 'Move to last column' }
  ];
  selectedCaseId: string;
  selectedCase: any;
  filterAllTesCaseData: any;
  moduleName: any;
  filterStepDataForParam: any;
  allTestCaseData: any;
  visibleIndex: any=[];
  parameterValueForUpdate: any;
  functionDataForUpdate: any;
  textParameter: any;
  selectedfValue: any;
  valuechanged: boolean;
  currentFunction: any;
  eventwithoutSpace: any;
  selectedFunctionValues: any;
  selectedKeys: any[];
  elementKeyData: any;
  locatorData: any;
  locatorId: any;
  elementEntryKeyData: any;
  testStepAtSelectedIndex: any;
  arr: any;
  // project: any;
  selectedScreen: any;
  projectData: any;
  locatorValueData: any;
  locatorEntryMapValue: any;
  locatorEntryCommentValue: any;
  keyForinsertComment: any;
  valueForUpdate1: string;
  valueForInsert: any;
  locatorValueIndex: any;
  @ViewChild("cancelAddLocator") cancelAddLocator: ElementRef;
  cancelUpdateLocator: any;
  selectedGvar: any;
  locatorManagementCheck: boolean = false;
  addScreenCheck: boolean = true;
  addLocatorsForm: UntypedFormGroup;
  updateLocatorsForm: UntypedFormGroup;
  editLocatorTitleForm: UntypedFormGroup;
  createRCForm: UntypedFormGroup;
  enableSideNav: boolean =true;
  allBranches: any;
  selectedBranches: any;
  headerOptions = {
    showSetting: true,
    showSearch: false,
    heading: 'Flow-chart',
    data: undefined,
  }
  undernestedCommand: any;
  BranchName: any;
  testStepdataBranch: any;
  groupedActionDataCopy1: any;
  showSuggestion: boolean;
  globalSearch: any;
  // urlService: any;
  groupNameDis: any;
  clubbedActions: any;
  actionsFilter: any;
  ActionName: any;
  subFunctionsCollections: any;
  showSubFunctionFlag: boolean;
  selectedIndexArray: any[];
  selectedIndexArray1: any[];
  cutTestStepArray: { list: any; };
  selectedIndexArray2: any[];
  testStepArray: { id: any; teststepList: any[]; };
  selectedIndexArray3: any[];
  checkedIndex: any;
  checkboxes: any;
  enableCopy: boolean;
  enableCut: boolean;
  enablePaste: boolean;
  browserRefresh = false;
  subscription: Subscription;
  resPonseCheck: any;
  testStepIndexForInsert: any;
  stepIndexForInsertComment: any;
  typeCheck: any;
  valueForUpdate: any;
  formObj: any;
  enableBUtton: boolean;
  testStepdata1: any;
  branchActivated: any;
  projectName: any;
  breadCrumb: any;
  selectedSteps: any = [];
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  currentTestSteps: any;
  subscriptoin2: Subscription;
  rcCategoryList : any;
  selectedRCCategory: any;
  selectedRc: any
  draggedRC: any;
  isRCDragged : boolean = false;
  rcId: any;
  rcBehav: any;
  rcCat: any;
  currentRcCat: any;
  currentRcForUpdate: any;
  locatorCommentMap: any;
  subscription4: Subscription;
  enableChild: boolean=false;
  selectedScreenName: string;
draggedSteps: any=[];
extractionList: any[] = [];
redactionList: any[] = [];
  userEmail: any;
  functionDragEnable: boolean;
  functionCopy: any;

  constructor(private stepRegistry: NgFlowchartStepRegistry,
    private dropDataService: DropDataService,
    private testCase: TestService,
    private route: ActivatedRoute,
    private setting: SettingService,
    private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
    private urlService :UrlService,
    private confirmationDialogService:ConfirmationDialogService,
    private toastrService: ToastrService,
    private router:Router,
    private project: ProjectService,
    private userManagement: UserMgmtService,
    private userService: UserService,
    private homeService: HomeService,
    private redactionService: RedactionService
    
  ) {
    this.initAllForms();
    this.url = environment.baseUrl;
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    this.callbacks.onDropError = this.onDropError;
    this.callbacks.onMoveError = this.onMoveError;
    this.callbacks.afterDeleteStep = this.afterDeleteStep;
    this.callbacks.beforeDeleteStep = this.beforeDeleteStep;
    this.callbacks.onLinkConnector = this.onLinkConnector;
    this.callbacks.afterDeleteConnector = this.afterDeleteConnector;
    // this.callbacks.afterScale = this.afterScale.bind(this);
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.browserRefresh = !router.navigated;
        console.log(this.browserRefresh, 'reloadTest');
        
      }
      console.log(this.browserRefresh, 'reloadTest');
       
  });
    this.getGroupedAction();
    
    // this.subscription4 = this.testCase.getTestSteps().subscribe((res: any) => {
    //   console.log("Test123 : ", res);
    //   this.currentTestSteps = res;
    //   let flowchartView = { "root": this.convertTableToFlowchart(this.currentTestSteps), "connectors": [] };
    //   this.sampleJson = flowchartView;
    //   this.showUpload();

    // })
  }
  
  ngOnInit() {

    this.loadUser();
    this.getFunction();
    this.getActions();
    this.route.paramMap.subscribe(
      (params: any) => {
        this.projectId = params.get('pid');
        this.testId = params.get('tid');
        this.testStepId = params.get('tsid')
        if(this.projectId=='rc'){
          this.rcCat = params.get('tid');
           this.rcId = params.get('tsid');
           this.headerOptions.showSetting = false;
           this.headerOptions.heading ='Reusable Component',

          //  this.getBranches(this.projectId,this.testId,this.testStepdata['teststepList'])
           this.headerOptions.data = {
          projectId: undefined,
          projectName: this.rcCat
        };
           this.getRC();
           console.log(this.rcCategoryList);
           this.homeService.setHeaderOptions(this.headerOptions);
           
         }


         else{
          
        this.getRC();
        localStorage.setItem('testForRecoder', params.get('tsid'));
        localStorage.setItem('projectIdForRecoder', params.get('pid'));
        localStorage.setItem('taskIdForRecorder', params.get('tid'));

        var res = JSON.parse(localStorage.getItem('projectDataById'));
        if(res){
        this.projectData = res;
        this.headerOptions.data = {
          projectId: this.projectId,
          projectName: res['projectName']
        };
        
        this.homeService.setHeaderOptions(this.headerOptions);
        this.projectName = res['projectName'];
      this.projectType = this.projectData.projectType;
      this.projectName = this.projectData.projectName;
        this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
        this.testCase.getIncludedTestCases(this.projectId).subscribe(
          (data) => {
            console.log("Test123 : ", data);
            this.allTestCaseData = data['testCaseData'];
            // localStorage.setItem('includedTestCase', JSON.stringify(this.allTestCaseData))
            this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId && f.branch[0] === "false");
            // this.filterAllTesCaseData = this.filterObjects(allTestCase);
            console.log(this.filterAllTesCaseData);
    
            
            
          })
        // this.inItFlowChart();
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
        subscribe(
          (data) => {
            this.testStepdata = data;
            this.testCaseType = this.testStepdata.testCaseType
            this.moduleName = this.testStepdata.path;
            this.moduleName = this.moduleName.split(',')
          try{
            localStorage.setItem('testStepdata', JSON.stringify(this.testStepdata));
          }
           catch{
            this.toastrService.clear();
            this.toastrService.warning('Project size is bigger will take some time to load please wait.')
           }
            // ////this.testStepdata);
      
       
            if (this.testStepdata['teststepList']) {
              this.testStep = this.testStepdata.teststepList;
              for (let i = 0; i < this.testStep.length; i++) {

                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;

              }
              this.getBranches(this.projectId,this.testId,this.testStepdata['teststepList'])
            //   this.testCase.getBranchList(this.projectId,this.testId).subscribe(
            //     (data)=>{
            //       console.log("Test123 : ", data);
            //       this.allBranches = data;
            //   // console.log("afterBranch : ", res);
            // var branchData = []
            //         for (let index = 0; index < this.testStep?.length; index++) {
            //           const element = this.testStep[index];
            //           if(element.commandName=='HITL' && element.parameters.settingValue.length>10){
            //             console.log('firstparam' ,element.parameters.settingValue);
            //             var branchIdArray = element.parameters.settingValue.split(",");
            //             console.log('bArray',branchIdArray);
            //             branchIdArray.forEach((element1,i)=> {
                         
            //                 branchData.push(this.returnBranchSteps(element1))
                          
            //             });
            //             element.branchData = branchData;
            //           }
                      
            //         }
            //         localStorage.setItem('localData',JSON.stringify(this.testStep))
            //         var setLocally = JSON.parse(localStorage.getItem('localData'));
            //      console.log('ashu123',res);
         
            //   this.testStep = setLocally;
            //   this.testStepCopy = JSON.parse(JSON.stringify(setLocally));
            //   console.log("goutham12123 : ", this.convertTableToFlowchart(this.testStep));
            //     let flowchartView = { "root": this.convertTableToFlowchart(this.testStep), "connectors": [] };
                
            //     this.sampleJson = flowchartView;
            //     this.showUpload();
               

            // })
              // if(this.browserRefresh != false){
              //   this.testCase.shareTestSteps(this.testStep);
              // }
              
            }
           
            else{
              this.testStep = []
            }
            this.getLocator();
          }
        )


       
      // this.testCase.getTestSteps().subscribe((res) => {
      //     console.log("Test123 : ", res);
      //     this.resPonseCheck = res;
      //     // if(res==null){
      //     // let flowchartView = { "root": this.convertTableToFlowchart([]), "connectors": [] };
      //     // console.log("goutham12123 : ", flowchartView);
      //     // this.sampleJson = flowchartView;
      //     // this.showUpload();
      //     // }

      //   })
    
        this.getBranches(this.projectId,this.testId);
      }
        else{
          this.project.getProjectById(this.projectId).subscribe((res) => {
        this.projectData = res;
        this.headerOptions.data = {
          projectId: this.projectId,
          projectName: res["projectName"],
        };
       
        this.homeService.setHeaderOptions(this.headerOptions);
        
        this.projectName = res['projectName'];
      this.projectType = this.projectData.projectType;
      this.projectName = this.projectData.projectName;
        this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
        this.testCase.getIncludedTestCases(this.projectId).subscribe(
          (data) => {
            console.log("Test123 : ", data);
            this.allTestCaseData = data['testCaseData'];
            // localStorage.setItem('includedTestCase', JSON.stringify(this.allTestCaseData))
            this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId && f.branch[0] === "false");
            // this.filterAllTesCaseData = this.filterObjects(allTestCase);
            console.log(this.filterAllTesCaseData);
    
            
            
          })
        // this.inItFlowChart();
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
        subscribe(
          (data) => {
            this.testStepdata = data;
            this.testCaseType = this.testStepdata.testCaseType
            this.moduleName = this.testStepdata.path;
            this.moduleName = this.moduleName.split(',')
          try{
            localStorage.setItem('testStepdata', JSON.stringify(this.testStepdata));
          }
           catch{
            this.toastrService.clear();
            this.toastrService.warning('Project size is bigger will take some time to load please wait.')
           }
            // ////this.testStepdata);
      
       
            if (this.testStepdata['teststepList']) {
              this.testStep = this.testStepdata.teststepList;
              for (let i = 0; i < this.testStep.length; i++) {

                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;

              }
              this.getBranches(this.projectId,this.testId,this.testStepdata['teststepList'])
            //   this.testCase.getBranchList(this.projectId,this.testId).subscribe(
            //     (data)=>{
            //       console.log("Test123 : ", data);
            //       this.allBranches = data;
            //   // console.log("afterBranch : ", res);
            // var branchData = []
            //         for (let index = 0; index < this.testStep?.length; index++) {
            //           const element = this.testStep[index];
            //           if(element.commandName=='HITL' && element.parameters.settingValue.length>10){
            //             console.log('firstparam' ,element.parameters.settingValue);
            //             var branchIdArray = element.parameters.settingValue.split(",");
            //             console.log('bArray',branchIdArray);
            //             branchIdArray.forEach((element1,i)=> {
                         
            //                 branchData.push(this.returnBranchSteps(element1))
                          
            //             });
            //             element.branchData = branchData;
            //           }
                      
            //         }
            //         localStorage.setItem('localData',JSON.stringify(this.testStep))
            //         var setLocally = JSON.parse(localStorage.getItem('localData'));
            //      console.log('ashu123',res);
         
            //   this.testStep = setLocally;
            //   this.testStepCopy = JSON.parse(JSON.stringify(setLocally));
            //   console.log("goutham12123 : ", this.convertTableToFlowchart(this.testStep));
            //     let flowchartView = { "root": this.convertTableToFlowchart(this.testStep), "connectors": [] };
                
            //     this.sampleJson = flowchartView;
            //     this.showUpload();
               

            // })
              // if(this.browserRefresh != false){
              //   this.testCase.shareTestSteps(this.testStep);
              // }
              
            }
           
            else{
              this.testStep = []
            }
            this.getLocator();
          }
        )


       
      // this.testCase.getTestSteps().subscribe((res) => {
      //     console.log("Test123 : ", res);
      //     this.resPonseCheck = res;
      //     // if(res==null){
      //     // let flowchartView = { "root": this.convertTableToFlowchart([]), "connectors": [] };
      //     // console.log("goutham12123 : ", flowchartView);
      //     // this.sampleJson = flowchartView;
      //     // this.showUpload();
      //     // }

      //   })
    
        this.getBranches(this.projectId,this.testId);
      });
        }
        //set header details
      }  
    })

    if(this.projectId!='rc'){

    
      this.testStepdata = JSON.parse(localStorage.getItem('testStepdata'))
      localStorage.setItem('testStepdata', JSON.stringify(this.testStepdata));
    //console.log("hello");


    //creating HITL
    // this.dropDataService.buildHITL.subscribe((res) => {
    //   setTimeout(() => {
    //     this.createHITLOnDrop(res,'ASHU','GOW');
    //   }, 0)
    // })

    // reset Selected Fields
    // this.testCase.updatedSelectedStep([]);

    this.subscription1 = this.testCase.reloadHITL.subscribe((res) => {

      if(res)
      {
        this.createHITL(res);
      }
    })

    let stepsWithOutHITL;
    setTimeout(() => {
      this.subscription2=this.testCase.getSelectedData().subscribe((res)=>
        {
    
          stepsWithOutHITL = [];
          if(this.testStepdata?.teststepList){
          this.testStepdata.teststepList.forEach(element => {
            if(element.commandName != 'HITL')
              {
                stepsWithOutHITL.push(element)
              }
          });
          
          this.selectedSteps = res;
          this.checkAllTestSteps = stepsWithOutHITL.length == this.selectedSteps.length &&  stepsWithOutHITL.length != 0 ? true : false;
          // this.testCase.setSelectedData(this.selectedSteps);
          console.log("check all : ", this.checkAllTestSteps);
        }
        })
    }, 500);
   
  }
  else{
    this.testStepdata = []
  }
    this.editLocatorTitleForm = this.formBuilder.group({
      name: ['', [Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/), Validators.required]],
    })

    this.addLocatorsForm = this.formBuilder.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      comment: ['']
    })

    this.updateLocatorsForm = this.formBuilder.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      comment: ['']
    })
  }

  initAllForms()
  {
    this.createRCForm = this.formBuilder.group({
      componentName: ["", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      componentType: ["public", [Validators.required]],
      category: ["", [Validators.required]]
    });
  }
//   @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
//     console.log("Processing beforeunload...");
//     // Do more processing...
//     this.testCase.shareTestSteps(this.testStep);
//     event.returnValue = false;
// }
// @HostListener("window:unload", ["$event"]) unloadHandler1(event: Event) {
//   console.log("After unloadunload...");
//   // Do more processing...
//   this.testCase.shareTestSteps(this.testStep);
//   event.returnValue = false;
// }

  // get commands API


 filterObjects(array) {
    return array.filter(obj => {
        // Check if teststepList exists and does not contain commandName "HITL"
        if (obj.teststepList) {
            const hasHITL = obj.teststepList.some(step => step.commandName === "HITL");
            return !hasHITL && obj.branch && obj.branch[0] === "false";
        } else {
            // If teststepList does not exist, check only branch[0]
            return obj.branch && obj.branch[0] === "false";
        }
    });
}

// Given array (replace with your actual array)
// Filter the array

  getActions() {
    this.testCase.getAction(this.projectType).subscribe(
      (data) => {
        console.log("Test123 : ", data);
        if (data && data.list && data.list.length !== this.actions.length) {
          for (var i = 0; i < data.list.length; i++) {
            if (typeof (data.list[i]) == 'string' && JSON.parse(data.list[i])) {
              var obj = JSON.parse(data.list[i]);
              this.actions.push(obj);
            }
          }
          this.actions = _.chain(this.actions).sortBy('name').value();
          this.commandJson = {
            "list": this.actions
          }
          console.log(this.commandJson);
          localStorage.setItem('actions', JSON.stringify(this.actions));
          this.actionSteps();
         
        }
        ////"actions : ", this.actions);
      });
  }

  getFunction() {
    var functionMethodNames = {};
    if (this.functions.length === 0) {
      //console.log("entry1");
      this.testCase.getFunction().subscribe((data) => {
        //console.log("entry2", data);
        console.log("Test123 : ", data);
        if (data && data.list && data.list.length !== this.functions.length) {
          for (var i = 0; i < data.list.length; i++) {
            // if(typeof(data.list[i]) == 'string' && JSON.parse(data.list[i])){
            var obj = JSON.parse(data.list[i]);
            //console.log("objcheck", obj);
            this.functions.push(obj);
            functionMethodNames[obj.method] = obj.method;
            // }
          }
        }
        this.functions = _.chain(this.functions).sortBy('name').value();
        console.log('function', this.functions);
        // this.mapActionPse();
        //console.log("func", this.functions);

      });
    } else {
      return true;
    }

  }
  loadFunction = function () {
    var functionMethodNames = {};
    if (this.functions.length === 0) {
      this.testCase.getFunction().subscribe((data) => {
        console.log("Test123 : ", data);
        if (data && data.list && data.list.length !== this.functions.length) {
          for (var i = 0; i < data.list.length; i++) {
            var obj = JSON.parse(data.list[i]);
            this.functions.push(obj);
            functionMethodNames[obj.method] = obj.method;
          }
        }
        this.functions = _.chain(this.functions).sortBy('name').value();
        this.functionJson = {
          "list": this.functions
        }
        setTimeout(() => {
          this.functionJson = {
            "list": this.functions
          }
          this.functionSteps()
          localStorage.setItem('functions', JSON.stringify(this.functions));

        }, 2000);
      });
    }
  }
  actionSteps() {
    for (let i of this.commandJson.list) {
      let commands:any = [] ;
      commands.name = i.name;
      commands.desc = i.desc;
      this.commandList.push(commands);
    }
    for (let c of this.commandList) {
      let palette:any = {};
      let steps = {};
      let data = {
      };
    
      if (c.name === 'IF' || c.name === 'FOR') {
        data['commandName'] = c.name;
        data['desc'] = c.desc;
        data['testStepId'] = this.testStepId;
        data['projectId'] = this.projectId;
        data['index'] = 1;
        data['pseCommand'] = c.name;
        steps['template'] = FormStep2Component;
        steps['data'] = data;
      } 
      else if (c.name === 'HITL') {
        data['commandName'] = c.name;
        data['desc'] = c.desc;
        data['testStepId'] = this.testStepId;
        data['projectId'] = this.projectId;
        data['index'] = 1;
        data['pseCommand'] = c.name;
        steps['template'] = FormStepComponent;
        steps['data'] = data;
      }
      else {
        data['commandName'] = c.name;
        data['desc'] = c.desc;
        data['testStepId'] = this.testStepId;
        data['projectId'] = this.projectId;
        data['index'] = 1;
        data['pseCommand'] = c.name;
        steps['template'] = FormStep1Component;
        steps['data'] = data;
     }
      // steps['type'] = c.name.toLowerCase(),
      steps['type'] = 'form-step1',
        palette['paletteName'] = c.name;
      palette['step'] = steps;
      // this.customOps.push(palette)
    }

    console.log('commandSteps', this.customOps);
    console.log('pallete', this.commandSteps);
    for (let r of this.commandSteps) {
        this.stepRegistry.registerStep(r.step.type, FormStepComponent);
    }

  }

  functionSteps() {
    for (let i of this.functionJson.list) {
      let functionForSteps:any;
      functionForSteps.name = i.name;
      functionForSteps.desc = i.description;
      this.functionList.push(functionForSteps);
    }
    for (let c of this.functionList) {
      let palette = {};
      let steps = {};
      let data = {};

        data['commandName'] = c.name;
        data['desc'] = c.desc;
        steps['template'] = FormStep1Component;
        steps['data'] = data;
      steps['type'] = 'form-step1',
        palette['paletteName'] = c.name;
      palette['step'] = steps;
      this.functionStep.push(palette)
    }

    for (let r of this.functionStep) {
      this.stepRegistry.registerStep(r.step.type, FormStep2Component);
    }

  }
  ngAfterViewInit() {
    this.stepRegistry.registerStep('log', this.normalStepTemplate);
    this.stepRegistry.registerStep('router', CustomStepComponent);
    this.stepRegistry.registerStep('nested-flow', NestedFlowComponent);
    this.stepRegistry.registerStep('form-step', FormStepComponent);
    this.stepRegistry.registerStep('form-step1', FormStep1Component);
    this.stepRegistry.registerStep('form-step2', FormStep2Component);
    this.stepRegistry.registerStep('form-step3', FormStep3Component);
    this.stepRegistry.registerStep('route-step', RouteStepComponent);
    // this.showUpload();
    this.fetchStepFromFlow();
    setTimeout(() => {
      this.testCase.getStepForEdit().subscribe(
        (data)=>{
          console.log("Test123 : ", data);
          console.log('editDatafl',data);
          if(data){
            this.editEnable(data,data.stepIndex)
          }
        
        }
      )
    }, 1000);
  //  if(this.functionDragEnable){
  //   this.formButton.nativeElement.click();

  //       this.selectBox.nativeElement.click();
  //  }
  
  }

  onDropError(error: NgFlowchart.DropError) {
    console.log(error);
  }

  onMoveError(error: NgFlowchart.MoveError) {
    console.log(error);
  }

  beforeDeleteStep(step) {
    console.log(JSON.stringify(step.children));
  }

  afterDeleteStep(step) {
    console.log(JSON.stringify(step.children));
  }

  onLinkConnector(conn) {
    console.log(conn);
  }

  afterDeleteConnector(conn) {
    console.log(conn);
  }

  afterScale(scale: number): void {
    //realistically you want to recursively get all steps in canvas
    const firstSetOfChildren = this.canvas.getFlow().getRoot().children;
    firstSetOfChildren.forEach(step => {
      if (step instanceof NestedFlowComponent) {
        step.nestedCanvas.setNestedScale(scale);
      }
    });
  }

  showUpload() {
    console.log("uploading.. ", this.sampleJson);
    this.canvas.getFlow().upload(this.sampleJson);
  }

  showFlowData() {
    let json = this.canvas.getFlow().toJSON(4);

    var x = window.open();
    x.document.open();
    x.document.write(
      '<html><head><title>Flowchart Json</title></head><body><pre>' +
        json +
        '</pre></body></html>'
    );
    x.document.close();
    this.fetchStepFromFlow();
  }

  clearData() {
    this.canvas.getFlow().clear();
  }

  onGapChanged(event) {
    this.options = {
      ...this.canvas.options,
      stepGap: parseInt(event.target.value),
    };
  }

  onSequentialChange(event) {
    this.options = {
      ...this.canvas.options,
      isSequential: event.target.checked,
    };
  }

  onOrientationChange(event) {
    this.canvas.setOrientation(
      event.target.checked ? 'HORIZONTAL' : 'VERTICAL'
    );
  }

  onDelete(id) {
    this.canvas.getFlow().getStep(id).destroy(true);
  }
  onGrow() {
    this.canvas.scaleUp();
  }
  onShrink() {
    this.canvas.scaleDown();
  }
  onReset() {
    this.canvas.setScale(1);
  }

  fetchStepFromFlow()
  {
    let json = this.canvas.getFlow().toJSON(4);
    setTimeout(()=>
    {
      console.log(json);
    }, 1000)

  }

  createHITLOnDrop(stepId , branch1, branch2) {
      let newData = {
        "name": "Nested Flow",
        "nested": {
            "root": {
                "id": 's' + Date.now(),
                "type": "form-step",
                "data": "HITL",
                "children": [
                    {
                        "id": 's' + Date.now() + 1, // incrementing id to make it unique
                        "type": "form-step2",
                        "data": {},

                        "children": []
                    },
                    {
                        "id": 's' + Date.now() + 2, // incrementing id to make it unique
                        "type": "form-step2",
                        "data": { },
                        "children": []
                    }
                ]
            },
            "connectors": []
        }
    }
    // let newData = {
    //   "name": "Nested Flow",
    //   "nested": {
    //     "root": {
    //       "id": 's' + Date.now(),
    //       "type": "form-step",
    //       "data": "HITL",
    //       "children": []
    //     },
    //     "connectors": []
    //   }
    // }
    this.modifyNodeById(stepId, newData)
  }

  createHITL(data)
  {
    console.log("before1 creating..", data)
    let id = data.parentId;
    let newData = data.children;
    let flow : any = this.canvas.getFlow().toJSON(4);
    let jsonObj = typeof flow === 'string' ? JSON.parse(flow) : flow;
    let root = jsonObj.root;
    let branchData = this.connectBranchWithHITL(newData);
    console.log("branch Data: ", branchData, newData);
    let updatedFlow = {root : root};
    console.log("before creating..", updatedFlow)
    // this.canvas.getFlow().upload(updatedFlow);
  }

  createBranchFlow(node: any, id: string, newData: any)
  {
    if (node.id === id) {
      node.data = newData;
    }
    if (node.children && Array.isArray(node.children)) {
      node.children.forEach(child => {
        this.recursiveModify(child, id, newData);
      });
    }
  }

  connectBranchWithHITL(newData)
  {
    newData = newData.filter(function( element ) {
      return element !== undefined;
   });
    let branchList: any = [];
    newData.forEach(element => {
      if(!element.id){
        return;
      }
      let obj = {
        id: element.id,
        type: "form-step2",
        data: element,
        children:[]
      }
      if(element.testStepList.length)
      {
        obj['children'].push(this.connectStepsWithBranch(element.testStepList))
      }
      branchList.push(obj)
    });
    console.log('branchList',branchList);
    return branchList;
    
    
  }

  connectStepsWithBranch(testSteps)
  {
    if (!testSteps.length) {
      return;
    }
    const [first, ...rest] = testSteps;
    return {
      id: this.generateRandomId(),
      type: "form-step1",
      data: first,
      children: this.connectStepsWithBranch(rest) == null ? [] : [this.connectStepsWithBranch(rest)]
    };
  }


  modifyNodeById(id: string, newData: any) {
    let flow : any = this.canvas.getFlow().toJSON(4);
    let jsonObj = typeof flow === 'string' ? JSON.parse(flow) : flow;
    let root = jsonObj.root;
    this.recursiveModify(root, id, newData);
    let updatedFlow = {root : root};
    console.log("before creating..", updatedFlow)
    this.canvas.getFlow().upload(updatedFlow);
  }

  private recursiveModify(node: any, id: string, newData: any) {
    if (node.id === id) {
      node.data = newData;
    }
    if (node.children && Array.isArray(node.children)) {
      node.children.forEach(child => {
        this.recursiveModify(child, id, newData);
      });
    }
  }
  @ViewChild(NgFlowchartCanvasDirective)
  nestedCanvas: NgFlowchartCanvasDirective;


  testDrop(value) {
   
    this.contentDiv[0]['fieldlist'] = []
    this.functionDataForUpdate = [];
    this.selectedFunction = undefined;
    let json = this.canvas.getFlow();
    this.draggedSteps = [];
    console.log('rcNew',this.draggedRC);
    this.selectedKeys2 = [];
    this.selectedKeys1 = [];
    // this.functionDragEnable = false;
    if(this.draggedRC && this.draggedRC.children)
    {
      this.draggedSteps = []
    
      this.draggedSteps = this.draggedRC.children.testSteps;
      this.draggedSteps.forEach(element => {
        if(element.stepComment){
          element.comment = element.stepComment;
        }
        
      });
    }

    if(!this.draggedSteps)
    {
      this.toastrService.clear();
      this.toastrService.warning("This Reusable doesn't not contain any steps, please add and try again.");
      return;
    }


    // console.log("index : ", json.canvas.currentDropTarget.step.data.stepIndex, json.canvas.currentDropTarget.position);
    // console.log("dragged steps : ", this.draggedSteps);

    if(this.draggedSteps.length > 0)
    {
      if(json.canvas.currentDropTarget && json.canvas.currentDropTarget.position=='BELOW'){
        this.addBelow(json.canvas.currentDropTarget.step.data.stepIndex + 1, null, '', this.draggedSteps)
      }
      if(json.canvas.currentDropTarget && json.canvas.currentDropTarget.position=='ABOVE'){
        this.addBelow(json.canvas.currentDropTarget.step.data.stepIndex, null, '', this.draggedSteps)
      }
      else if(!json.canvas.currentDropTarget ){
        this.addBelow(0, null, '', this.draggedSteps)
      }
     
      return;
    }
    


    console.log(value['srcElement'].innerText);
    this.stepOptions = undefined;
    setTimeout(() => {

      console.log('nested321', this.nestedCanvas);

      let json = this.canvas.getFlow();

      if (this.isRCDragged) {
        this.addRcToFlow(json.canvas.currentDropTarget.step.data.stepIndex, json.canvas.currentDropTarget.position)
        return;
      }

      console.log('target', json.canvas.currentDropTarget);
      var stepData = json.canvas.flow.steps
      console.log('stepData', stepData);
      if (stepData.length == 1) {
        this.addRow(this.undernestedCommand)
      }

      if (stepData.length > 1) {
        var stepDataO = stepData[stepData.length - 1]
        console.log(stepDataO.data);
        // this.stepOptions = stepDataO.data
        if (stepDataO.data.commandName != 'HITL' && json.canvas.currentDropTarget.step.type != 'nested-flow') {
          this.testCase.setStepForEdit(undefined)

          if (json.canvas.currentDropTarget.position == "BELOW") {
            this.addBelow(json.canvas.currentDropTarget.step.data.stepIndex + 1, 'ADD', this.undernestedCommand);
          }
          else if (json.canvas.currentDropTarget.position == "ABOVE") {
            this.addBelow(json.canvas.currentDropTarget.step.data.stepIndex, 'ADD', this.undernestedCommand);
          }

          // if(!stepDataO.data.commandName){
          //   this.addBelow(json.canvas.currentDropTarget.step.data.stepIndex+1,'ADD',this.undernestedCommand);
          // }
        }
        //  else if(!this.testStep.length){
        //   this.addRow(stepDataO.data.commandName)
        //  } 
        if (json.canvas.currentDropTarget.step.type == 'nested-flow' && json.canvas.currentDropTarget.position == "BELOW") {
          this.testCase.setStepForEdit(undefined)
          this.addBelow(json.canvas.currentDropTarget.step.data.nested.root.data.stepIndex + 1, 'ADD', this.undernestedCommand);
        }
        else if (json.canvas.currentDropTarget.step.type == 'nested-flow' && json.canvas.currentDropTarget.position == "RIGHT" || json.canvas.currentDropTarget.position == "LEFT") {
          this.toastrService.clear();
          this.toastrService.warning('Dropping at wrong position, can drop below only');
          this.getLatestTestSteps();
          return;
        }
      }


    }, 1000);
  }


  dragging(value,type?:any,functionName?:any){
    // console.log(value);
    this.isRCDragged = false;
    this.undernestedCommand = value;
    if(type=='fun'){
      this.functions = JSON.parse(localStorage.getItem('functions'));
      this.functionDragEnable = true;
      this.currentFunction = functionName;
      this.undernestedCommand = 'SET';
    }
    else{
      this.functionDragEnable = false;
      this.currentFunction = undefined;
    }
  }

  rcDrag(rc)
  {
    this.draggedRC  = rc;
    this.isRCDragged = true;
  }

  addRcToFlow(index, position)
  {
    // console.log("Goutham RC :", index, position);

  }

  getLatestTestSteps()
  {
    this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
    subscribe(
      (data) => {
        this.testStepdata = data;
        this.testCaseType = this.testStepdata.testCaseType
        this.testStep = [];
        this.testStep = this.testStepdata.teststepList;
        for (let i = 0; i < this.testStep.length; i++) {
          // this.testStep[i] = {
          //    stepIndex:''
          //   }
          this.testStep[i].stepIndex = i;
          this.testStep[i].viewS = true;

        }
       
          this.testCase.shareTestSteps(this.testStep);
          setTimeout(() => {
          // this.testCase.setStepForEdit(this.testStep[lastIndex])
        }, 1000);
       
      })
  }
  canDrag(
    dropEvent: NgFlowchart.DropTarget,
    error: NgFlowchart.ErrorMessage
  ): boolean {
    console.log('flow',dropEvent, error)
    return true;
  }
  indexFormArray: UntypedFormArray;
  form: UntypedFormGroup;
  
  onselectCase(index: any, isChecked: boolean) {
    if(true){
   
     this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;
    
     if (isChecked) {
   
       this.indexFormArray.push(new UntypedFormControl(index));
       
       ////this.indexFormArray.value);
     } else {
       let Index = this.indexFormArray.controls.findIndex(x => x.value == index)
       this.indexFormArray.removeAt(Index);
     
    }
    this.selectedBranches = this.indexFormArray.value
    console.log('branchData',this.selectedBranches,this.indexFormArray);
    
       ////this.indexFormArray.value)
     }
   
   }
  createBranch(projectId,testSuiteId ){

   var objectToUpdate = {
    "branch": [
        {
            "branch": "Ashu1",
            "description": "This is branch two"
        },
        {
            "branch": "Vicky2",
            "description": "This is branch two"
        }
    ]
}
   this.testCase.createBranch(projectId,testSuiteId,objectToUpdate).subscribe(
    (data)=>{
      console.log("Test123 : ", data);
      console.log('branch created');
      
    }
   )
  }

  addBelow(lastIndex, buttonIdentifier, commandName?: string, testStepArray? : []) {
    ////"addBello");
    this.checkAllTestSteps = false;
    const items = this.testStep;
    //  const lastIndex =this.testStep.length;
    ////lastIndex);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]

    let result;

    if(testStepArray && testStepArray.length > 0)
    {
      items.splice(lastIndex, 0, ...testStepArray);
      result = items;
    }
    else {
      this.testStepCopy[0] = JSON.parse(JSON.stringify(this.testStep[0]));
    
   
      if (this.projectType === 'WEB') {
        this.testStepCopy[0].commandName = commandName;
        if(this.projectId=='rc'){
          this.testStepCopy[0].name = commandName;
        }
      } else if (this.projectType === 'DESKTOP') {
        this.testStepCopy[0].commandName = 'OPENDESKTOPAPP';
      } else if (this.projectType === 'MOBILE') {
        this.testStepCopy[0].commandName = 'OPENMOBILEAPP';
      } else if (this.projectType === 'MIXED') {
        this.testStepCopy[0].commandName = commandName;
        if(this.projectId=='rc'){
          this.testStepCopy[0].name = commandName;
        }
       
      }
      else if (this.projectType === 'REST') {
        this.testStepCopy[0].commandName = 'REQ_START';
      }
      else if (commandName) {
        this.testStepCopy[0].commandName = commandName;
        if(this.projectId=='rc'){
          this.testStepCopy[0].name = commandName;
        }
      }
      else {
        this.testStepCopy[0].commandName = 'OPENBROWSER';
      }
      this.testStepCopy[0].comment = '';
      this.testStepCopy[0].runtimeData = 'false';
      this.testStepCopy[0].elementKey = '';
      this.testStepCopy[0].parameters.settingValue = '';
      this.testStepCopy[0].parameters.isMasked = 'false';
      this.testStepCopy[0].pageName = '';
      this.testStepCopy[0].type = 'AUTOMATIC';
      this.testStepCopy[0].active = 'ENABLE';
      if (this.testCaseType == 'MANUAL') {
        this.testStepCopy[0].type = 'MANUAL';
      }
      // if(this.projectId=='rc'){
      //   delete this.testStepCopy[0].commandName;
      // }
      let HITLCount = 0;
  
      if(this.testStepCopy[0])
      {
        this.testStepCopy.forEach((element)=>
          {
            if(element.commandName == 'HITL')
            {
              HITLCount = HITLCount + 1;
            }
          })
      }
  
  
      if(HITLCount > 1)
      {
        console.log("More than one HITL found ");
        return;
      }
  
       result = insert(items, lastIndex, this.testStepCopy[0])
    }

    ////this.testStep[0]);
    ////"insert", result);
    // [1, 10, 2, 3, 4, 5]
    var testStepAtSelectedIndex = this.testStepCopy[0];
    // ////"fromTestStep",this.testStepAtSelectedIndex);
    // testStepAtSelectedIndex.push(this.testStep);

    ////"Create", this.testStep);
    // this.projectId;
    ////this.projectId);
    ////this.testStepId);
    this.testStepdata.teststepList = result;
    ////"Create", result);
    this.testStepCopy = JSON.parse(JSON.stringify(result));
    this.testCopyFlowChart = JSON.parse(JSON.stringify(result));
    // this.loadFlowchart(result);
    for (let i = 0; i < this.testStepCopy.length; i++) {
      // this.testStep[i] = {
      //    stepIndex:''
      //   }
      this.testStepCopy[i].stepIndex = i;
      this.testCopyFlowChart[i].stepIndex = i;
      ////this.testStep);
      // this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
      ////this.testStepCopy);


    }
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    const myObject = createTestStepData[0];
    if(this.projectId!='rc'){
    this.testCase.editTestCase(this.projectId, this.testId, createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);

          this.testStepdata = data;
          this.testCaseType = this.testStepdata.testCaseType
          this.testStep = this.testStepdata.teststepList;
          if(!testStepArray){
            this.draggedRC = undefined;
            this.draggedSteps = undefined;
          }
          if(true){
            for (let i = 0; i < this.testStepdata.teststepList.length; i++) {
              // this.testStep[i] = {
              //    stepIndex:''
              //   }
              this.testStepdata.teststepList[i].stepIndex = i;
              this.testStepdata.teststepList[i].viewS = true;
              ////this.testStep);
              this.visibleIndexForCardTip = this.testStepdata.teststepList.length
              
              
            }
            // if(commandName == 'HITL' || commandName == 'Branch1' || commandName == 'Branch1'){
            //   this.createBranch(this.projectId,this.testId)
              // this.dropDataService.buildHITL.subscribe((res) => {
              //   setTimeout(() => {
              //     this.createHITLOnDrop(res,'branch1','branch2');
              //   }, 0)
              // })
              // return;
            //  }
            //  else{
              this.testCase.shareTestSteps(JSON.parse(JSON.stringify(this.testStepdata.teststepList)));
            // this.testCase.getTestSteps().subscribe((res) => {
            //   console.log("goutham12123 : ", res);
            //    var branchData = []
            //   for (let index = 0; index < res.length; index++) {
            //     const element = res[index];
            //     if(element.commandName=='HITL' && element.parameters.settingValue.length>10){
            //       console.log('firstparam' ,element.parameters.settingValue);
            //       var branchIdArray = element.parameters.settingValue.split(",");
            //       console.log('bArray',branchIdArray);
            //       branchIdArray.forEach((element1,i)=> {
            //         branchData.push(this.returnBranchSteps(element1))
            //       });
            //       element.branchData = branchData;
            //     }
                
            //   }
            //   console.log("Ashu123 : ", res);
            //   localStorage.setItem('localData',JSON.stringify(res))
             
            //   var setLocally = JSON.parse(localStorage.getItem('localData'));
        
            //   this.testStep = setLocally;
            //   this.testStepCopy = JSON.parse(JSON.stringify(setLocally));
            //   let flowchartView = { "root": this.convertTableToFlowchart(setLocally)};
            //   console.log("goutham12123 : ", flowchartView);
            //   this.sampleJson = flowchartView;
            //   this.showUpload();
            // })
            //  this.stepOptions = undefined;
             this.stepOptions = this.testStep[lastIndex]
              // this.stepOptions = stepDataO.data
              this.stepOptions.index = lastIndex;
              this.stepOptions.projectId = this.projectId;
              // this.stepOptions.parentId=this.testId ;
              this.stepOptions.testStepId = this.testStepId; 
              this.objectForEditTestStep = this.stepOptions;
              this.editEnable(this.objectForEditTestStep,lastIndex)
              if(this.draggedRC?.children.id){
              this.testCase.checkRc(this.draggedRC.children.id,this.projectId).subscribe(
                (res:any)=>{
                  console.log(res);
                  this.draggedRC = undefined

                }
              )
              }
              
            // }
          
          }
        }
      });
    }
    if(this.projectId=='rc'){
      this.testStepdata.teststepList.forEach(element => {
        if(element.stepComment){
          element.comment = element.stepComment;
        }
        
      });
    this.updateRc(this.currentRcForUpdate.children.componentName,this.currentRcForUpdate.children.accessType,this.rcCat,this.testStepdata.teststepList,this.rcId)
    }
  }

  convertTableToFlowchart(testSteps: any)
  {
    if (testSteps?.length == 0) {
      return [];
    }
  
    const [first, ...rest] = testSteps;
    if(first.commandName == 'HITL' && first.branchData){
      console.log('first' ,first.branchData);
    //   // if(first.parameters.settingValue.length>1){
       
    //     // branchIdArray.forEach(element => {
         
    //     //  this.returnBranchSteps(element).title;
    //     //   element.branchSteps = this.returnBranchSteps(element).testStepList
          
    //     // });
    //     // console.log('branchData',branchData );
        
    //   // }
    // connectBranchWithHITL(newData)
    var sampleNested = {
      "id": "s1719051736895",
      "type": "nested-flow",
      "data": {
        "name": "Nested Flow",
        "nested": {
          "root": {
            "id": this.generateRandomId(),
            "type": "form-step",
            data: first,
            index: first.stepIndex,
            children: this.connectBranchWithHITL(first.branchData) == null ? [] : this.connectBranchWithHITL(first.branchData)
          }
        }
      },
      children: rest.length == 0 ? [] : [this.convertTableToFlowchart(rest)]
    
    }

      return sampleNested
    }
    else{
      return {
        id: this.generateRandomId(),
        type: "form-step1",
        data: first,
        children: rest.length == 0 ? [] : [this.convertTableToFlowchart(rest)]
      };
    }
   

  }
  HITLStepsToFlowchart(testSteps: any)
  {
    if (!testSteps.length) {
      return;
    }
  
    const [first, ...rest] = testSteps;
   
      return {
        id: this.generateRandomId(),
        type: "form-step1",
        data: first,
        children: this.HITLStepsToFlowchart(rest) == null ? [] : [this.HITLStepsToFlowchart(rest)]
      };
    
   

  }
  getBranches(projectId,testSuiteId,testSteps?:any){
    if(testSteps){
      this.currentTestSteps = testSteps 
   


        this.testCase.getBranchList(projectId,testSuiteId).subscribe(
          (data)=>{
            console.log("Test123 : ", data);
            this.allBranches = data;
            // this.onReset()
        console.log("afterBranch : ", this.currentTestSteps);
      var branchData = []
              for (let index = 0; index < this.currentTestSteps?.length; index++) {
                const element = this.currentTestSteps[index];
                if(element.commandName=='HITL' && element.parameters.settingValue.length>10){
                  console.log('firstparam' ,element.parameters.settingValue);
                  var branchIdArray = element.parameters.settingValue.split(",");
                  console.log('bArray',branchIdArray);
                  branchIdArray.forEach((element1,i)=> {
                   
                      branchData.push(this.returnBranchSteps(element1))
                    
                  });
                  element.branchData = branchData;
                }
                
              }
        //       localStorage.setItem('localData',JSON.stringify(this.currentTestSteps))
        //       var setLocally = JSON.parse(localStorage.getItem('localData'));
        //    console.log('ashu123',this.currentTestSteps);
   
        // this.testStep = setLocally;
        // this.testStepCopy = JSON.parse(JSON.stringify(setLocally));
        //  console.log('latestSteps',this.convertTableToFlowchart(this.currentTestSteps));
  
        let flowchartView = { "root": this.convertTableToFlowchart(this.currentTestSteps), "connectors": [] };
        this.sampleJson = flowchartView;
        this.showUpload();
        // this.onReset()
  

        // this.canvas1.reRender(true);.

       
      })
    
    }
    else{
     this.subscriptoin2 =  this.testCase.getTestSteps().subscribe((res: any) => {
        console.log("Test123 : ", res);
        this.currentTestSteps = res
        this.stepOptions = undefined;
        if(res)
        {
          this.testStepdata['teststepList'] = res;
          this.testCase.getBranchList(projectId,testSuiteId).subscribe(
            (data)=>{
              console.log("Test123 : ", data);
              this.allBranches = data;
              // this.onReset()
          console.log("afterBranch : ", res);
        var branchData = []
                for (let index = 0; index < res?.length; index++) {
                  const element = res[index];
                  if(element.commandName=='HITL' && element.parameters.settingValue.length>10){
                    console.log('firstparam' ,element.parameters.settingValue);
                    var branchIdArray = element.parameters.settingValue.split(",");
                    console.log('bArray',branchIdArray);
                    branchIdArray.forEach((element1,i)=> {
                     
                        branchData.push(this.returnBranchSteps(element1))
                      
                    });
                    element.branchData = branchData;
                  }
                  
                }
                localStorage.setItem('localData',JSON.stringify(res))
                var setLocally = JSON.parse(localStorage.getItem('localData'));
             console.log('ashu123',res);
     
          this.testStep = setLocally;
          this.testStepCopy = JSON.parse(JSON.stringify(setLocally));
           console.log('latestSteps',this.convertTableToFlowchart(res));
    
          let flowchartView = { "root": this.convertTableToFlowchart(res), "connectors": [] };
          this.sampleJson = flowchartView;
          this.showUpload();
          // this.onReset()
    
  
          // this.canvas1.reRender(true);.
  
         
        })
        }

     
      
      })
    }

   
      
  }
  returnBranchSteps(Id){
 var branchSteps = this.allBranches.find((f)=>f.id==Id);
 if(branchSteps){
  branchSteps.testStepList.forEach((element,i) => {
    element.stepIndex = i;
    element.parentId = branchSteps.id;
  });
  return branchSteps;
 }
}
  generateRandomId(length: number = 14): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }
  getCurrentStep(value){
    console.log(value);
    

  }
  
  switchMenu() {
    this.stepOptions = undefined
    this.enableSideNav = !this.enableSideNav
    if (window.outerWidth <= 1024) {
      this.menuMobileShown = !this.menuMobileShown;
    } else {
      this.menuDesktopHidden = !this.menuDesktopHidden;
    }
    var element = document.getElementsByClassName("wrapper")[0];
    if (this.menuMobileShown) {
      element.classList.add("menu-mobile-shown");
    } else {
      element.classList.remove("menu-mobile-shown");
    }
    if (this.menuDesktopHidden) {
      element.classList.add("menu-desktop-hidden");
    } else {
      element.classList.remove("menu-desktop-hidden");
    }
  };

  switchMenu2() {
    if (window.outerWidth <= 1024) {
      this.menuMobileShown = !this.menuMobileShown;
    } else {
      this.menuDesktopHidden = !this.menuDesktopHidden;
    }
    var element = document.getElementsByClassName("wrapper")[0];
    if (this.menuMobileShown) {
      element.classList.add("menu-mobile-shown2");
    } else {
      element.classList.remove("menu-mobile-shown2");
    }
    if (this.menuDesktopHidden) {
      element.classList.add("menu-desktop-hidden2");
    } else {
      element.classList.remove("menu-desktop-hidden2");
    }
  };
  bindTitle(title) {
    if (title != 'sub') {
      return title;
    }
    else if (title == 'sub') {
      return 'Can not drag this , please click to expand and drag from the expanded';
    }
  }
  editEnable(testStep, index?: any, enableEdit?: boolean) {
   this.selectedKeys1=[];
   this.selectedKeys2 = [];
   
    if(true){
    this.onRawClick();
    this.contentDiv[0]['result4']=[];
    
  this.selectedFunction = undefined;
    this.enableTextField = false;
    if(index>0){
      
    }
    // this.selectedCase = undefined;
    // this.selectedTestCase=undefined;
    this.contentDiv = [{
      "parameterType": undefined,
      "parameterValue": undefined
    }];
    this.optionSelected = [];
    this.objectForEditTestStep = undefined
    if(testStep?.parameters?.settingValue.includes("extraction") || testStep?.parameters?.settingValue.includes("redaction")){
              this.getRedactionDetails();
      }
    // this.objectForEditTestStep = undefined;
    // this.testStepUpdateForm.resetForm();
    if (testStep) {
      this.BranchName = undefined
      this.stepOptions = testStep;
      if(testStep.parentId){
        this.getBranchSteps(testStep.parentId)
        this.BranchName = this.allBranches.find((f)=>f.id==testStep.parentId)
        testStep.commandName = testStep.name
      }
      this.objectForEditTestStepCopy = JSON.parse(JSON.stringify(testStep));
     
      this.objectForEditTestStep = testStep;
      this.pseCommand = this.actionsMetaDataCopy[this.objectForEditTestStep.commandName]
      if (this.objectForEditTestStep.commandName === 'STARTHIGHLIGHT' || this.objectForEditTestStep.commandName === 'CLEARHIGHLIGHT') {
        this.loadStartHighlightSelection(this.objectForEditTestStep.parameters?.settingValue || '');
      }
      if (this.objectForEditTestStep.commandName === 'MENUCLICK') {
        this.loadMenuClickSelection(this.objectForEditTestStep.parameters?.settingValue || '');
      }
      if (this.objectForEditTestStep.commandName === 'MOVEHIGHLIGHT') {
        this.loadMoveHighlightSelection(this.objectForEditTestStep.parameters?.settingValue || '');
      }
      
   
      if(this.pseCommand){
        this.enableEdit = true;
      }
      else{
        this.enableEdit = false;
        this.stepOptions = undefined
      }
      this.enableEditForm = false;
     
      if (enableEdit) {
        
        setTimeout(() => {
          console.log(this.stepTab.nativeElement.click());
        }, 0);
        // this.stepTab.nativeElement.click();
        this.enableEditForm = enableEdit
        this.enableEdit = false;
        if (this.objectForEditTestStep.commandName == 'INVOKETEST') {
          if (this.objectForEditTestStep.parameters.settingValue.indexOf('&') == -1) {
            this.loadTestStepData = true;
            return;
          }
          this.objectForEditTestStep.iteration = this.objectForEditTestStep.parameters.settingValue.substr((this.objectForEditTestStep.parameters.settingValue.indexOf('&') + 1), this.objectForEditTestStep.length);
          this.objectForEditTestStep.parameters.settingValue = this.objectForEditTestStep.parameters.settingValue.substr(0, this.objectForEditTestStep.parameters.settingValue.indexOf('&'));
          this.objectForEditTestStep.parameters.settingValue = this.getParameterName(this.objectForEditTestStep.parameters.settingValue);
          this.selectedTestCase = this.objectForEditTestStepCopy.parameters['settingValue'].substr(0, this.objectForEditTestStepCopy.parameters['settingValue'].indexOf('&'));
          //console.log('selectedId', this.selectedTestCase);
          if (this.selectedTestCase) {
            this.onChangeInvoke(this.selectedTestCase, true)
          }
  
        }
       

      }
      if (index == 0 || index > 0) {
        this.openSingleCard(index)
        this.stepIndexTobeEdit = index;
        this.performedAction = 'Add'
        this.enableEditForm = true;
        // this.objectForEditTestStepCopy = this.objectForEditTestStep
        if (this.objectForEditTestStep.commandName == 'INVOKETEST') {
          if (this.objectForEditTestStep.parameters.settingValue.indexOf('&') == -1) {
            this.loadTestStepData = true;
            return;
          }
          this.objectForEditTestStep.iteration = this.objectForEditTestStep.parameters.settingValue.substr((this.objectForEditTestStep.parameters.settingValue.indexOf('&') + 1), this.objectForEditTestStep.length);
          this.objectForEditTestStep.parameters.settingValue = this.objectForEditTestStep.parameters.settingValue.substr(0, this.objectForEditTestStep.parameters.settingValue.indexOf('&'));
          this.objectForEditTestStep.parameters.settingValue = this.getParameterName(this.objectForEditTestStep.parameters.settingValue);
          this.selectedTestCase = this.objectForEditTestStepCopy.parameters['settingValue'].substr(0, this.objectForEditTestStepCopy.parameters['settingValue'].indexOf('&'));
          //console.log('selectedId', this.selectedTestCase);
          if (this.selectedTestCase) {
            this.onChangeInvoke(this.selectedTestCase, true)
          }
  
        }
        this.enableEdit = false;
      }
      else {
        this.stepIndexTobeEdit = testStep.stepIndex;
        this.openSingleCard(this.stepIndexTobeEdit)
        this.performedAction = 'Edit'
        if (this.objectForEditTestStep.commandName == 'INVOKETEST') {
          if (this.objectForEditTestStep.parameters.settingValue.indexOf('&') == -1) {
            this.loadTestStepData = true;
            return;
          }
          this.objectForEditTestStep.iteration = this.objectForEditTestStep.parameters.settingValue.substr((this.objectForEditTestStep.parameters.settingValue.indexOf('&') + 1), this.objectForEditTestStep.length);
          this.objectForEditTestStep.parameters.settingValue = this.objectForEditTestStep.parameters.settingValue.substr(0, this.objectForEditTestStep.parameters.settingValue.indexOf('&'));
          this.objectForEditTestStep.parameters.settingValue = this.getParameterName(this.objectForEditTestStep.parameters.settingValue);
          this.selectedTestCase = this.objectForEditTestStepCopy.parameters['settingValue'].substr(0, this.objectForEditTestStepCopy.parameters['settingValue'].indexOf('&'));
          //console.log('selectedId', this.selectedTestCase);
          if (this.selectedTestCase) {
            this.onChangeInvoke(this.selectedTestCase, true)
          }
  
        }
      }
    }
  }
  }
  onRawClick() {
    if (this.rawclicked == false) {
      this.showDiv.previous = !this.showDiv.previous;
      this.showDiv.current = false;
      this.showDiv.next = false;
      this.rawclicked = true;
      this.formclicked = false;
    }
    this.selectChangeHandler('Text', 0);
    if(this.functionDragEnable){
      this.optionSelected = []
      setTimeout(() => {
        this.functionDragEnable = false;
        this.selectBox.nativeElement.click();
        this.optionSelected.push('Function');
      this.selectChangeHandler('Function', 0);
      this.contentDiv[0]['fieldlist'] =[]
      this.selectfunctionHandler(this.selectedFunction, 0);
      }, 1500);
        
    }
  }
  onChangeInvoke(id: string, isChecked: boolean,testCaseData?:any) {
console.log(testCaseData);
this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + testCaseData.parentTestDataId+ '/' + id).
    subscribe(
      (data) => {
        if(data['teststepList']){
       var allSteps:any = data['teststepList'];
       var findHItlSteps  = allSteps.find((f)=>f.commandName=='HITL')
       if(findHItlSteps){
        this.toastrService.clear();
        this.toastrService.warning('This case contains HITL steps, can not include this case');
        isChecked=false
        return;
       }
       else{
        if (isChecked) {
          //console.log(id);
          this.selectedCaseId = id;
          this.selectedCase = this.filterAllTesCaseData.filter((f => f.id == id))
          //console.log(this.selectedCase);
          this.moduleName = this.selectedCase[0].path.split(',');
        }
       }
      }
      else{
        this.toastrService.clear();
        this.toastrService.warning('This case does not contains any steps, can not include this case');
        isChecked=false
        return;
      }
      })
    

  }
  openSingleCard(i) {
    if (this.enableEdit === false) {
      return;
    }
    else if (this.enableEditForm == true) {
      this.enableEditForm == true
    }

    // if ($('#flexSwitchCheckDefault').is(':checked')) {
    //   this.toastrService.clear();
    //   this.toastrService.warning('You have enabled Expanded View, Switch To Standard View ');
    //   return;
    // }
    if (this.visibleIndex.length == 0) {
      this.visibleIndex.push(i);

    }

    if (this.visibleIndex.length > 0) {
      if (this.visibleIndex.includes(i)) {
        let index = this.visibleIndex.indexOf(i);
        delete this.visibleIndex[index]
      }
      else {
        this.visibleIndex[0] = i;
      }
    }
    if(this.functionDragEnable){
      // selectChangeHandler($event.target.value, contentIndex)
      this.selectedFunction = this.currentFunction;
      setTimeout(() => {
        this.formButton.nativeElement.click();
        
        
      }, 1000);

    }
  }
  getIncludedTestCases() {
    this.testCase.getIncludedTestCases(this.projectId).subscribe(
      (data) => {
        console.log("Test123 : ", data);
        this.allTestCaseData = data['testCaseData'];
        localStorage.setItem('includedTestCase', JSON.stringify(this.allTestCaseData))
        this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId);
         this.filterAllTesCaseData = this.filterObjects(this.filterAllTesCaseData);
        for (let i = 0; i < this.testStepCopy.length; i++) {
          if (this.testStepCopy[i].commandName == 'INVOKETEST') {
            if (this.testStepCopy[i].parameters.settingValue.indexOf('&') == -1) {
              this.loadTestStepData = true;
              return;
            }
            this.testStepCopy[i].iteration = this.testStepCopy[i].parameters.settingValue.substr((this.testStepCopy[i].parameters.settingValue.indexOf('&') + 1), this.testStepCopy[i].length);
            var inId = this.testStepCopy[i].parameters.settingValue.replace('&1','');
            this.testStepCopy[i].parameters.settingValue = this.testStepCopy[i].parameters.settingValue.substr(0, this.testStepCopy[i].parameters.settingValue.indexOf('&'));
            this.testStepCopy[i].parameters.settingValue = this.getParameterName(this.testStepCopy[i].parameters.settingValue);


            this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == inId);
            this.testCase.getTestSuiteData(this.projectId,this.filterStepDataForParam[0].parentTestDataId)
            .subscribe((data) => {
              console.log("Test123 : ", data);
                console.log('data of suite parent ', data);
                this.testStepCopy[i].includeHref = '#/test/TestStep/'+this.projectId+'/'+data['id']+'/'+inId;
            })
            console.log('this.testStepCopy[i]', this.testStepCopy[i]);
          }
          else {
            this.loadTestStepData = true;
          }
        }
      
        // this.testCopyFlowChart = JSON.parse(JSON.stringify(this.testStepCopy));
      }
    )
  }
  getParameterName(id) {
    this.loadTestStepData = true;
    this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == id);

    return this.filterStepDataForParam[0].path.replace(',', "").replaceAll(',', '/') + this.filterStepDataForParam[0].title;
  }
  addParameter() {
    // return;
    this.contentDiv.push({
      "parameterType": undefined,
      "parameterValue": undefined
    });
  }
  showDiv = {
    previous: false,
    current: false,
    next: false
  }
  selectChangeHandler(event: any, index) {
    //console.log(index);

    this.contentDiv[index].parameterType = event;
    this.selectedValue = event;
  }
  // showInnerText() {
  //   this.showDetail = !this.showDetail;
  //   if (this.showDetail) {
  //     this.detailDesplay = 'block'
  //   }
  //   else {
  //     this.detailDesplay = 'none'
  //   }

  // }
  manageParamOptions2 = ["Bugzilla", "GitLab", "Jira", "TFS", "TFS_PAT"];
  manageParamOptions = ["Text", "Global Variable", "Function"];
  bugzilla = ["bugzilla_password", "bugzilla_url", "bugzilla_username", "type"];
  // bugZillaObjectForUpdate=[{"key":"bugzilla_password","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_url","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_username","value":"","$$hashKey":"object:6459"},{"key":"type","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_password","value":"","$$hashKey":"object:6459"}]
  gitlab = ["gitlab_password", "gitlab_project", "gitlab_project_namespace", "gitlab_url", "gitlab_username"];
  jira = ["jira_password", "jira_project", "jira_url", "jira_userName"];
  tfs = ["tfs_metadata", "tfs_password", "tfs_project", "tfs_url", "tfs_username"];
  tfsPAT = ["tfs_metadata", "tfs_password", "tfs_project", "tfs_url", "tfs_username"];
  keys = ["NULL", "CANCEL", "HELP", "BACKSPACE", "TAB", "CLEAR", "RETURN", "ENTER", "SHIFT", "LEFT_SHIFT", "CONTROL", "LEFT_CONTROL", "ALT", "LEFT_ALT"
    , "PAUSE", "ESCAPE", "SPACE", "PAGE_UP", "PAGE_DOWN", "END", "HOME", "LEFT", "ARROW_LEFT", "UP", "ARROW_UP", "RIGHT", "ARROW_RIGHT", "DOWN"
    , "ARROW_DOWN", "INSERT", "DELETE", "SEMICOLON", "EQUALS", "F1", "F2", "F3", "F4", "F5", "F6"];
  keyValueFunctions = ["extraction","redaction","filehandle", "pdfHandle", "dataCompare", "getJsonValue", "sqlDump", "getXmlValue", "ntlmtoken", "oauthtoken", "jsonCompare", "deletefile", "verifytext", "watchfile", "copyfile", "loadcsv", "couchbasesql", "filevalidate", "loadtestData", "wordEmbedded", "pdfmerge", "getCellReference", "setCellReference", "loadExcelTable", "excelHandle", "runCmdProcess", "csvvalidate", "getColumnSumExcel"];
  contentDiv = [{
    "parameterType": undefined,
    "parameterValue": undefined
  }];
  selectChangeAction(event: any) {
    var selAction = this.actions.find((f)=>f.pseAction==event.target.value) ;
    this.selectedAction = selAction?.name;
    if (this.objectForEditTestStep && selAction?.name) {
      this.objectForEditTestStep.commandName = selAction.name;
    }
    if (selAction?.name === 'STARTHIGHLIGHT' || selAction?.name === 'CLEARHIGHLIGHT') {
      this.loadStartHighlightSelection(this.objectForEditTestStep?.parameters?.settingValue || '');
    } else if (selAction?.name === 'MENUCLICK') {
      this.loadMenuClickSelection(this.objectForEditTestStep?.parameters?.settingValue || '');
    } else if (selAction?.name === 'MOVEHIGHLIGHT') {
      this.loadMoveHighlightSelection(this.objectForEditTestStep?.parameters?.settingValue || '');
    }
  // this.testStepAtSelectedIndex.actionDescription = this.actionDescription;
      // console.log('desc',this.actionDescription);
    console.log(this.selectedAction);

  }

  get isStartHighlight(): boolean {
    return this.objectForEditTestStep?.commandName === 'STARTHIGHLIGHT';
  }

  get isMenuClick(): boolean {
    return this.objectForEditTestStep?.commandName === 'MENUCLICK';
  }

  get isMoveHighlight(): boolean {
    return this.objectForEditTestStep?.commandName === 'MOVEHIGHLIGHT';
  }

  get isClearHighlight(): boolean {
    return this.objectForEditTestStep?.commandName === 'CLEARHIGHLIGHT';
  }

  get isHighlightResultField(): boolean {
    return this.isStartHighlight || this.isMoveHighlight || this.isClearHighlight || this.isMenuClick;
  }

  get showMoveVerticalCount(): boolean {
    return this.moveHighlightVertical === 'DOWN' || this.moveHighlightVertical === 'UP';
  }

  get showMoveHorizontalCount(): boolean {
    return this.moveHighlightHorizontal === 'LEFT' || this.moveHighlightHorizontal === 'RIGHT';
  }

  buildStartHighlightRaw(): string {
    return JSON.stringify({
      locator: this.startHighlightLocator || '',
      resolvedRow: this.startHighlightRow || '',
      resolvedColumn: this.startHighlightColumn || ''
    });
  }

  buildMenuClickRaw(): string {
    return JSON.stringify({
      locator: this.menuClickLocator || '',
      menuPath: this.menuClickPath || ''
    });
  }

  private isLeakedStartHighlightJson(value: any): boolean {
    if (value == null || String(value).trim() === '') {
      return false;
    }
    try {
      const parsed = JSON.parse(String(value));
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return false;
      }
      const isStart = Object.prototype.hasOwnProperty.call(parsed, 'locator')
        && Object.prototype.hasOwnProperty.call(parsed, 'resolvedRow')
        && Object.prototype.hasOwnProperty.call(parsed, 'resolvedColumn');
      const isMenu = Object.prototype.hasOwnProperty.call(parsed, 'locator')
        && Object.prototype.hasOwnProperty.call(parsed, 'menuPath')
        && !Object.prototype.hasOwnProperty.call(parsed, 'resolvedRow');
      const isMove = Object.prototype.hasOwnProperty.call(parsed, 'locator')
        && Object.prototype.hasOwnProperty.call(parsed, 'currentRow')
        && Object.prototype.hasOwnProperty.call(parsed, 'verticalMove');
      return isStart || isMove || isMenu;
    } catch {
      return false;
    }
  }

  loadStartHighlightSelection(settingValue: string) {
    this.startHighlightLocator = '';
    this.startHighlightRow = '';
    this.startHighlightColumn = '';
    if (!settingValue || !String(settingValue).trim()) {
      return;
    }
    try {
      const saved = JSON.parse(settingValue);
      this.startHighlightLocator = saved?.locator || '';
      this.startHighlightRow = saved?.resolvedRow != null ? String(saved.resolvedRow) : '';
      this.startHighlightColumn = saved?.resolvedColumn != null ? String(saved.resolvedColumn) : '';
    } catch {
      // Hand-edited or empty params; leave the fields blank.
    }
  }

  loadMenuClickSelection(settingValue: string) {
    this.menuClickLocator = '';
    this.menuClickPath = '';
    if (!settingValue || !String(settingValue).trim()) {
      return;
    }
    try {
      const saved = JSON.parse(settingValue);
      this.menuClickLocator = saved?.locator || '';
      this.menuClickPath = saved?.menuPath != null ? String(saved.menuPath) : '';
      if (!this.menuClickPath) {
        this.refreshMenuClickPathFromLocator();
      }
    } catch {
      // Hand-edited or empty params; leave the fields blank.
    }
  }

  onMenuClickLocatorChange() {
    this.refreshMenuClickPathFromLocator();
  }

  private refreshMenuClickPathFromLocator() {
    const derived = this.deriveMenuPathFromLocator(this.menuClickLocator);
    if (derived) {
      this.menuClickPath = derived;
    }
  }

  private deriveMenuPathFromLocator(locatorKey: string): string {
    if (!locatorKey) {
      return '';
    }
    const entries = Array.isArray(this.elementEntryKeyData) ? this.elementEntryKeyData : [];
    const entry = entries.find((e: any) => e?.key === locatorKey);
    const raw = entry == null ? '' : String(entry.value || entry.locatorValue || '');
    const stripped = raw.replace(/^(NAME|ID|XPATH|UIAUTOMATION|CLASS|CSS|TAGNAME)\s*=\s*/i, '').trim();
    return stripped || locatorKey;
  }

  buildMoveHighlightRaw(): string {
    return JSON.stringify({
      locator: this.moveHighlightLocator || '',
      currentRow: this.moveHighlightCurrentRow || '',
      currentColumn: this.moveHighlightCurrentColumn || '',
      verticalMove: this.moveHighlightVertical || 'NONE',
      verticalCount: this.moveHighlightVerticalCount || '1',
      horizontalMove: this.moveHighlightHorizontal || 'NONE',
      horizontalCount: this.moveHighlightHorizontalCount || '1'
    });
  }

  loadMoveHighlightSelection(settingValue: string) {
    this.moveHighlightLocator = '';
    this.moveHighlightCurrentRow = '';
    this.moveHighlightCurrentColumn = '';
    this.moveHighlightVertical = 'NONE';
    this.moveHighlightVerticalCount = '1';
    this.moveHighlightHorizontal = 'NONE';
    this.moveHighlightHorizontalCount = '1';
    if (!settingValue || !String(settingValue).trim()) {
      return;
    }
    try {
      const saved = JSON.parse(settingValue);
      this.moveHighlightLocator = saved?.locator || '';
      this.moveHighlightCurrentRow = saved?.currentRow != null ? String(saved.currentRow) : '';
      this.moveHighlightCurrentColumn = saved?.currentColumn != null ? String(saved.currentColumn) : '';
      this.moveHighlightVertical = saved?.verticalMove || 'NONE';
      this.moveHighlightVerticalCount = saved?.verticalCount != null && String(saved.verticalCount) !== ''
        ? String(saved.verticalCount) : '1';
      this.moveHighlightHorizontal = saved?.horizontalMove || 'NONE';
      this.moveHighlightHorizontalCount = saved?.horizontalCount != null && String(saved.horizontalCount) !== ''
        ? String(saved.horizontalCount) : '1';
    } catch {
      // Hand-edited or empty params; leave the defaults.
    }
  }

  loadActionsMetaData() {
    return this.groupedActionData.forEach(groupedActionItem => {
      groupedActionItem.children.forEach(action => {
        if (action.type == 'action') {
          this.actionsMetaData[action?.children?.name] = action?.name;
          this.actionsMetaDataCopy[action?.children?.name] = action?.name;
        } else if (action.type == 'fun') {
          this.actionsMetaData[action?.function?.name] = action?.name;
          this.actionsMetaDataCopy[action?.function?.name] = action?.name;
        } else if (action.type == 'sub') {
          this.actionsMetaData[action.subfunction[0]?.children?.name] = action?.name;
          this.actionsMetaDataCopy[action.subfunction[0].children?.name] = action?.name;
          // action.subfunction[0]
          // action.subfunction.forEach(subfunction => {
          //   this.actionsMetaData[subfunction.children.name] = subfunction.name;
          // });
        }
      });
      this.actionsMetaData['OPEN'] = 'Open Web Browser';
      this.actionsMetaDataCopy['OPEN'] = 'Open Web Browser';
    });

  }

  getGroupedAction() {
    return this.testCase.getGroupedAction().subscribe(
      (res) => {
        console.log("Test123 : ", res);
        this.groupedActionData = res;
        localStorage.setItem('groupedActionData', JSON.stringify(this.groupedActionData))
        console.log(this.groupedActionData);

        this.colors = ["#956fa1", "#7aa19f", "#49A1F1", "#3685F6", "#6750A4", "#8E7AAE", "#FDBA13",
          "#EAB62F", "#F58820", "#d080d9", "#5DA6B7", "#f5817d", "#B5D654", "#44B94A",
          "#5CB587", "#2C8B7F", "#c9b5b3", "#EB4D3D", "#9cdbad", "#9cd6cc", "#68ada1",
          "#e8b3f2", "#c293cc", "#d199c8", "#f590e4", "#d6c696", "#ffe28a", "#f7a06d"
        ];

        var Icons = [
          "fab fa-chrome",
          "fas fa-location-arrow",
          "fas fa-file-word",
          "fas fa-file-excel",
          "fas fa-folder-plus",
          "fas fa-mobile-alt",
          "fas fa-recycle",
          "fas fa-database",
          "fas fa-desktop",
          "fas fa-spell-check",
          "fas fa-pause-circle",
          "fas fa-sitemap",
          "fas fa-terminal",
          "fas fa-file-pdf",
          "fas fa-keyboard",
          "fas fa-mouse",
          "fas fa-file-csv",
          "fas fa-exclamation-triangle",
          "fas fa-check-double",
          "fas fa-hand-pointer",
          "fas fa-toolbox",
          "fas fa-images",
          "fas fa-file-code",
          "fas fa-scroll",
          "fas fa-code-branch",
          "fas fa-laptop-code",
          "fas fa-tools",

        ]
        this.groupedActionData.forEach((element, i) => {
          element.groupColor = '#002d5b';
          element.children.forEach(elementChild => {
            let palette:any = {};
            let steps = {};
            let data = {
            };
          
            elementChild.color = element.groupColor;
            elementChild.icon = element.groupIcon;
            elementChild.icon = element.groupIcon;
            if(elementChild.type == 'action'){
              
              if(elementChild.children.name=='HITL'){
                data['commandName'] = elementChild.children.name;
                data['desc'] = elementChild.children.desc;
                data['testStepId'] = this.testStepId;
                data['projectId'] = this.projectId;
                data['index'] = 1;
                steps['template'] = FormStepComponent;
                steps['data'] = data;
                steps['type'] = 'form-step1',
                palette['paletteName'] = elementChild.children.name;
                palette['step'] = steps;
                elementChild['customOps']= palette;
              }
              else{
                data['commandName'] = elementChild.children.name;
              data['desc'] = elementChild.children.desc;
              data['testStepId'] = this.testStepId;
              data['projectId'] = this.projectId;
              data['index'] = 1;
              steps['template'] = FormStep1Component;
              steps['data'] = data;
              steps['type'] = 'form-step1',
              palette['paletteName'] = elementChild.children.name;
              palette['step'] = steps;
              elementChild['customOps']= palette;
              }
            }
           
            if (elementChild.type == 'sub') {
              
              elementChild['customOps']= palette;
              elementChild.subfunction.forEach(elementSub => {
                elementSub.color = element.groupColor;
                elementSub.icon = element.groupIcon;
                data['commandName'] = 'SET';
                // data['desc'] = elementChild.children.desc;
                data['testStepId'] = this.testStepId;
                data['projectId'] = this.projectId;
                data['index'] = 1;
                steps['template'] = FormStep1Component;
                steps['data'] = data;
                steps['type'] = 'form-step1',
                palette['paletteName'] = elementSub.name;
                palette['step'] = steps;
                // element.icon = Icons[i]
              });
            }
            if (elementChild.type == 'fun') {
              data['commandName'] = 'SET';
              data['functionName'] = elementChild?.function?.name;
              data['desc'] = elementChild?.function?.description;
              data['testStepId'] = this.testStepId;
              data['projectId'] = this.projectId;
              data['index'] = 1;
              steps['template'] = FormStep1Component;
              steps['data'] = data;
              steps['type'] = 'form-step1',
              palette['paletteName'] = elementChild.name;
              palette['step'] = steps;
              elementChild['customOps']= palette;
              // elementChild.subfunction.forEach(elementSub => {
              //   elementSub.color = element.groupColor;
              //   elementSub.icon = element.groupIcon;
               
              //   // element.icon = Icons[i]
              // });
            }
          
          });
        });
        this.groupedActionDataCopy = JSON.parse(JSON.stringify(this.groupedActionData))
        console.log('ata', this.groupedActionDataCopy);

        this.loadActionsMetaData();
        setTimeout(() => {
         
          this.mapActionPse(this.functions, this.actions);
        }, 2000);
        return;
      }
    )
  }
  async mapActionPse(functions, actions) {
    console.log('functionData', this.functions);
    functions.forEach(functionPse => {
      if (this.actionsMetaData[functionPse.name]) {
        functionPse['pseFunction'] = this.actionsMetaData[functionPse.name]
      }
      else {
        functionPse['pseFunction'] = functionPse.name;
      }
    });

    actions.forEach(actionPse => {
      if (this.actionsMetaData[actionPse.name]) {
        actionPse['pseAction'] = this.actionsMetaData[actionPse.name]
      }
      else {
        actionPse['pseAction'] = actionPse.name
      }
    }
    )
    this.functionCopy = JSON.parse(JSON.stringify(this.functions))
    localStorage.setItem('actions', JSON.stringify(this.actions));
    localStorage.setItem('functions', JSON.stringify(this.functions));
  }
  onFormClick() {
    if (this.formclicked == false) {
      this.showDiv.current = !this.showDiv.current;
      this.showDiv.previous = true;
      this.showDiv.next = false;
      this.rawclicked = false;
      this.formclicked = true;
    }
    var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    // this.testStepUpdateForm.reset();
    // this.contentDiv = [{
    //   "parameterType": undefined,
    //   "parameterValue": undefined
    // }];
    // console.log('form',this.testStepUpdateForm , 'content', this.contentDiv);
    this.contentDiv[0]['result4']=[];
    this.functionDataForUpdate = []
    this.segregateParameters(this.objectForEditTestStep.parameters['settingValue']);

    if (this.objectForEditTestStep.parameters['settingValue'].includes('{')) {
      this.parameterValueForUpdate = this.objectForEditTestStep.parameters['settingValue'].split('}');

      //console.log(this.parameterValueForUpdate);
      var indexCheck: boolean = false;
      var funCheck: boolean = false;
      for (let i = 0; i < this.parameterValueForUpdate.length; i++) {
        if (this.parameterValueForUpdate.length > 1) {

          if (this.parameterValueForUpdate[i].includes('${_')) {
            funCheck = true;
            if (indexCheck) {
              this.addParameter();
            }
            if (this.enableTextField) {
              this.addParameter();
            }
            // this.functionDataForUpdate = []
            for (let j = 0; j < this.functionDataForUpdate.length; j++) {
              if(this.contentDiv[0]['fieldlist'][j])
                {
                  this.contentDiv[0]['fieldlist'][j]['value'] = ''
                this.contentDiv[0]['fieldlist'][j]['value'] = this.functionDataForUpdate[j]
              }
              

            }

          }

        }

      }

    }
    else {

      if (funCheck) {
        this.addParameter();
      }
      if (indexCheck) {
        this.addParameter();
      }
      this.enableTextField = true;
      this.optionSelected.push('Text');
      this.selectChangeHandler('Text', 0);
      this.textParameter = this.objectForEditTestStep.parameters['settingValue'];
      this.contentDiv[0].parameterValue = this.textParameter;
    }
  }
  segregateParameters = function (input) {
    var paramValue = input;
    var func = "${__";
    var globalVar = "$G{";
    var localeVar = "$L{";
    var suiteVar = "$S{";
    var localVar = "${";
    var endVar = "}";
    var endFunc = ")}";
    var n = 0;
    var showDropdown = false;
    var parametersFormsSequence = new Array();
    var groups = {};
    groups[func] = endFunc;
    groups[globalVar] = endVar;
    groups[localeVar] = endVar;
    groups[suiteVar] = endVar;
    groups[localVar] = endVar;

    var arguments1 = {};
    var argumentIndex = 0;
    var increaseArgIndex = false;

    for (var i = 0; i < paramValue.length; i++) {
      if (paramValue.charAt(i) === '$') {
        if (func === paramValue.substring(i, i + 4)) {
          argumentIndex++;
          n = paramValue.indexOf(endFunc, i);
          arguments1[argumentIndex] = {};
          parametersFormsSequence.push(arguments1[argumentIndex]);
          //console.log(parametersFormsSequence);

          arguments1[argumentIndex].name = paramValue.substring(i + 4, paramValue.indexOf("(", i));
          arguments1[argumentIndex].type = "Function";
          // arguments1[argumentIndex].form =this.evaluateParamTemplate({type: arguments[argumentIndex].name});
          arguments1[argumentIndex].data1 = (paramValue.substring(i, n + 2));
          arguments1[argumentIndex].args = (arguments1[argumentIndex].data1.substring(arguments1[argumentIndex].data1.indexOf("(") + 1, arguments1[argumentIndex].data1.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //console.log('Args', arguments1[argumentIndex].args);
          //console.log('name', arguments1[argumentIndex].name);
          var selectedFunction = this.functions.filter((f) => f.method === arguments1[argumentIndex].name)
          this.optionSelected.push('Function');
          // //console.log('selectedFunction', selectedFunction);

          // this.selectBox.nativeElement.click();
          this.selectChangeHandler('Function', 0);
          this.selectedFunction = selectedFunction[0].pseFunction;
          this.selectfunctionHandler(selectedFunction[0].name, 0);
          if(selectedFunction[0].name=='Extraction' || selectedFunction[0].name=='Redaction'){


            let currentValue = this.objectForEditTestStep.parameters['settingValue'];
      
            // Split the string by commas
            const parts = currentValue.split(',');
        
            // Extract the first three parts and rebuild the base string
            const baseString = parts.slice(0, 3).join(',') + ')'; // Ensures it ends correctly
        
            // Store everything after the first three parts in a separate array
            const remainingParts = parts.slice(3);
            // Only modify the last item in remainingParts (if it exists)
            if (remainingParts.length > 0) {
              remainingParts[remainingParts.length - 1] = remainingParts[remainingParts.length - 1].trim().replace(/[)}]/g, '');
            }
      
            // Directly assign remainingParts to selectedKeys2
            this.selectedKeys2 = remainingParts;
      
            console.log('Extraction/Redaction List:', this.extractionList);
            console.log('Selected Keys2:', this.selectedKeys2);
            
          }
          
          this.functionDataForUpdate = arguments1[argumentIndex].args;
          //console.log(this.functionDataForUpdate);

          if (this.checkIfFunctionMethodNameExist(arguments1[argumentIndex].name) && n >= 0) {
            if (this.keyValueFunctions.includes(arguments1[1].name) || this.currentFunction.isKeyValueFunction) {
              var value = '';
              var activeFieldList = new Array();
              for (var k = 0; k < this.currentFunction.fieldList.length; k++) {
                if (this.currentFunction.fieldList[k].isVisible == true) {
                  activeFieldList.push(this.currentFunction.fieldList[k]);
                }
              }
              for (var j = 0; j < arguments1[argumentIndex].args.length; j++) {
                var data = arguments1[argumentIndex].args[j].split(/=(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                if (j === 0) {
                  value = data[1];
                  // this.contentDiv[0]['fieldlist'][j]['value']=data[1];
                  //console.log(this.contentDiv[0]);

                }
                if (activeFieldList.length > j) {
                  var matchingField = this.getFuntionField1(activeFieldList, data[0]);
                  /**
                   * If field is drop down then we will be adding all the dependent fields on the matching active field list.
                   */
                  if (matchingField && matchingField.type === 'dropdown') {
                    var matchingValues = this.getMatchingValues(this.getMatchingFields(this.currentFunction.fieldList, data[0]), data[1]);
                    for (var k = 0; k < matchingValues.length; k++) {
                      if (!this.getFuntionField1(activeFieldList, matchingValues[k].name)) {
                        activeFieldList.push(matchingValues[k]);
                      }
                      //console.log(activeFieldList);

                    }
                  }
                  arguments1[argumentIndex].args[j] = data[1];
                  //console.log(arguments1[argumentIndex]);

                  // this.contentDiv[0]['fieldlist'][j]['value']=data[1];
                } else if (this.currentFunction.variableFieldList && activeFieldList.length > 0) {
                  var fields = data[0].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                  var fieldObject = new Object();
                  for (var k = 0; k < fields.length; k++) {
                    if (fields[k] !== undefined && fields[k].length > 0) {
                      fieldObject[k] = fields[k];
                    }
                  }
                  arguments1[argumentIndex].args[j] = fieldObject;
                  //console.log(arguments1[argumentIndex]);

                }
              }
              this.onChangeFunctionDropdown(value, this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable, 0);
            } else if (arguments1[1].name === "exeexecute") {
              arguments1[argumentIndex].args = (arguments1[argumentIndex].data.substring(arguments1[argumentIndex].data1.indexOf("(") + 1, arguments1[argumentIndex].data1.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
            } else {
              if (this.currentFunction.type === 'variable') {
                for (let j = this.currentFunction.fieldList.length; j < arguments1[argumentIndex].args.length; j++) {
                  var fields = arguments1[argumentIndex].args[j].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                  var fieldObject = new Object();
                  for (var k = 0; k < fields.length; k++) {
                    if (fields[k] !== undefined && fields[k].length > 0) {
                      fieldObject[k] = fields[k];
                    }
                  }
                  arguments1[argumentIndex].args[j] = fieldObject;
                  // if(j>0){
                  //   this.addVariableFields(this.currentFunction.name,0,arguments1[argumentIndex].args[j][0])
                  // }

                }
              }
              console.log(arguments1[argumentIndex].args);
              for (let z = 1; z < arguments1[argumentIndex].args.length; z++) {

                this.addVariableFields(this.currentFunction.name, 0, arguments1[argumentIndex].args[z][0])


              }
              this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable, 0);
            }

            // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/function.html';
            i = n + 1;
            increaseArgIndex = true;
          } else {
            this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name);
            arguments1[argumentIndex].name = "";
            arguments1[argumentIndex].type = "Text";
            arguments1[argumentIndex].data = (paramValue.substring(i));
            // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/text.html';
            break;
          }

          //           if (this.checkIfFunctionMethodNameExist(arguments1[argumentIndex].name) && n >= 0) {
          //             if (this.keyValueFunctions.includes(arguments1[1].name) || this.currentFunction.isKeyValueFunction) {
          //                 var value = '';
          //                 var activeFieldList = new Array();
          //                 for (var k = 0; k < this.currentFunction.fieldList.length; k++) {
          //                     if (this.currentFunction.fieldList[k].isVisible == true) {
          //                         activeFieldList.push(this.currentFunction.fieldList[k]);
          //                     }
          //                 }
          //                 for (var j = 0; j < arguments1[argumentIndex].args.length; j++) {
          //                     var data = arguments1[argumentIndex].args[j].split(/=(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //                     if (j === 0) {
          //                         value = data[1];
          //                         // this.contentDiv[0]['fieldlist'][j]['value']=value;
          //                         //console.log(this.contentDiv[0]['fieldlist']);

          //                     }
          //                     if (activeFieldList.length > j) {
          //                         var matchingField = this.getFuntionField1(activeFieldList, data[0]);
          //                         /**
          //                          * If field is drop down then we will be adding all the dependent fields on the matching active field list.
          //                          */
          //                         if (matchingField && matchingField.type === 'dropdown') {
          //                             var matchingValues = this.getMatchingValues(this.getMatchingFields(this.currentFunction.fieldList, data[0]), data[1]);
          //                             for (var k = 0; k < matchingValues.length; k++) {
          //                                 if (this.getFuntionField1(activeFieldList, matchingValues[k].name)) {
          //                                     activeFieldList.push(matchingValues[k]);
          //                                 }

          //                             }
          //                         }
          //                         arguments1[argumentIndex].args[j] = data[1];
          //                         this.contentDiv[0]['fieldlist'][j]['value']=data[1];
          //                         //console.log(this.contentDiv[0]['fieldlist']);

          //                     } else if (this.currentFunction.variableFieldList && activeFieldList.length > 0) {
          //                         var fields = data[0].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //                         var fieldObject = new Object();
          //                         for (var k = 0; k < fields.length; k++) {
          //                             if (fields[k] !== undefined && fields[k].length > 0) {
          //                                 fieldObject[k] = fields[k];
          //                             }
          //                         }
          //                         arguments1[argumentIndex].args[j] = fieldObject;
          //                     }
          //                 }
          //                 this.onChangeFunctionDropdown(value, this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
          //             } else if (arguments1[1].name === "exeexecute") {
          //                 arguments1[argumentIndex].args = (arguments1[argumentIndex].data.substring(arguments1[argumentIndex].data.indexOf("(") + 1, arguments1[argumentIndex].data.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //             } else {
          //               if(this.currentFunction.type === 'variable') {
          //                   for(let j = this.currentFunction.fieldList.length;j<arguments1[argumentIndex].args.length;j++){
          //                       var fields = arguments1[argumentIndex].args[j].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //                       var fieldObject = new Object();
          //                       for (var k = 0; k < fields.length; k++) {
          //                         if (fields[k] !== undefined && fields[k].length > 0) {
          //                                   fieldObject[k] = fields[k];
          //                               }
          //                       }
          //                       arguments1[argumentIndex].args[j] = fieldObject;
          //                   }
          //               }
          //                 this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
          //             }
          // //console.log(this.contentDiv);

          //             // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/function.html';
          //             i = n + 1;
          //             increaseArgIndex = true;
          //         }
        }
        else if (globalVar === paramValue.substring(i, i + 3)) {
          argumentIndex++;
          n = paramValue.indexOf(endVar, i);
          arguments1[argumentIndex] = {};
          parametersFormsSequence.push(arguments1[argumentIndex]);
          if (n >= 0) {
            arguments1[argumentIndex].type = "Global Variable";
            arguments1[argumentIndex].data = (paramValue.substring(i, n + 1));
            arguments1[argumentIndex].value = (paramValue.substring(i + 3, n));
            //console.log('Global,',arguments1[argumentIndex].data)
            // arguments1[argumentIndex].template = 'modules/test/partials/modal/teststep/variable.html';
            i = n;
            increaseArgIndex = true;
            this.selectChangeHandler('Global Variable', 0);
            // this.globalVariableForUpdate = this.parameterValueForUpdate[i].slice(this.parameterValueForUpdate[i].indexOf('{') + 1, this.parameterValueForUpdate[i].length);
            this.optionSelected.push('Global Variable');
            this.selectedGlobalVar = this.globalVariableForUpdate = arguments1[argumentIndex].value;
            //console.log(this.globalVariableForUpdate);
            //console.log(this.contentDiv.length, this.contentDiv);

            this.selectedGVar(this.globalVariableForUpdate, 0)
          } else {
            arguments1[argumentIndex].type = "Text";
            arguments1[argumentIndex].data = (paramValue.substring(i));
            // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/text.html';
            break;
          }

        }
      }
    }



  };

  selectedGVar(event: any, index) {
    this.contentDiv[index].parameterValue = event;
    this.contentDiv[index].parameterValue = this.contentDiv[index].parameterValue;
    this.selectedGvar = event;
    //console.log(this.contentDiv[index].parameterValue);
  }
  selectfunctionHandler(event: any, index, identifier?: string) {
    console.log(event, index);
    this.contentDiv[0]['result4']=[];
    this.contentDiv[index]['fieldlist']=[]
    this.contentDiv[index].parameterValue = undefined
    if (identifier) {
      var functionName = this.functions.find((f) => f.pseFunction == event)
      if (functionName) {
        this.contentDiv[index].parameterValue = functionName.name;
        this.selectedfValue = functionName.name;
      }
      else {
        this.contentDiv[index].parameterValue = event;
        this.selectedfValue = event;
      }
    }
    else {
      this.contentDiv[index].parameterValue = event;
      this.selectedfValue = this.contentDiv[index].parameterValue;
    }

    // if(this.testStep[this.testStepIndex-1].parameters.includes('$')){
    //   this.contentDiv[index]['result1'][0]=this.functionDataForUpdate;
    // this.contentDiv[index]['result1']=this.contentDiv[index]['result1'];
    // }
    this.valuechanged = true;
    const funcData = this.functions.filter((f) => f.name === this.selectedfValue);
    this.currentFunction = funcData[0];
    // console.log(this.currentFunction);

    this.contentDiv[index]['type'] = [];
    this.contentDiv[index]['type'] = funcData[0].type;
    // this.contentDiv[index]['fieldlist'] = []
    this.contentDiv[index]['fieldlist'] = funcData[0].fieldList;
    this.currentFunction.fieldList = this.contentDiv[index]['fieldlist']
    // console.log(this.currentFunction);

    this.contentDiv[index]['methodname'] = []
    this.contentDiv[index]['methodname'] = funcData[0].method;
    this.contentDiv[index]['isKeyValueFunction'] = funcData[0].isKeyValueFunction;
    for (var i = 0; i < this.contentDiv[index]['fieldlist'].length; i++) {
      if (this.contentDiv[index]['fieldlist'][i].defaultValueType === 'dynamic') {
        this.getDynamicData(this.contentDiv[index]['methodname'], this.projectId, this.contentDiv[index]['fieldlist'][i]);
      }
    }



  }
  getDynamicData(methodName, projectId, field) {
    this.testCase.getdynamicDropDownData(methodName, projectId).subscribe(
      (data: any) => {
        console.log("Test123 : ", data);
        if (!Array.isArray(data.list)) {
          field.defaultValues = ''
          field.defaultValues = ['', data.list];
        }
        else {
          field.defaultValues = data.list;
          field.defaultValues.unshift(' ');
        }

      }
    )
  }
  addVariableFields(selectedFunction: string, index1, value?: string) {
    // this.contentDiv[index1]['result4']=[]
    this.functionCopy.forEach(element => {
      if (element.name == selectedFunction) {
        if (element.variableFieldList) {
          console.log(element.variableFieldList)
          if (this.contentDiv[index1]['result4'] == undefined) {
            this.contentDiv[index1]['result4'] = [];
          }
          if (value) {
            element.variableFieldList[0].value = value;
          }
          if (value == undefined) {
            element.variableFieldList[0].value = '';
          }

          let valArray = [];

          valArray.push(JSON.parse(JSON.stringify(element['variableFieldList'])));

          
          this.contentDiv[index1]['result4'].push(...JSON.parse(JSON.stringify(valArray)));



        }
      }
    });
    // console.log('result$', this.contentDiv[index1]['result4']);

  }
  deleteVField(index) {
    this.contentDiv[0]['result4'].splice(index, 1);
    console.log(this.contentDiv[0]['result4']);

  }
  myFunction(contentIndex) {
    this.contentDiv[contentIndex]['result2'] = [];
    //console.log(contentIndex);

  }
  selectfunctionValues(event: any, index, fieldName = "", isDecidable: boolean = false) {

    if (fieldName != '') {
      //console.log("inside if")
      let obj = { name: fieldName, value: event };
      this.contentDiv[index]['result3'] = [];
      this.contentDiv[index]['result3'].push(obj);
    }
    if (event.includes(' ')) {
      //console.log(event);
      this.eventwithoutSpace = event.replace(/\s/g, "")
      event = this.eventwithoutSpace;
    }
    this.contentDiv[index]['result'] = [];
    this.contentDiv[index]['result'] = event;
    this.contentDiv[index]['result2'] = [];
    this.contentDiv[index]['parameterArg'] = event;
    this.selectedFunctionValues = event;
    //console.log(this.selectedFunctionValues);
    if (!isDecidable) {
      return;
    }
    this.contentDiv[index]['Vfield'] = this.getFuntionField(this.contentDiv[index]['fieldlist'], this.selectedFunctionValues);
    // this.contentDiv[index]['Vfield'] = this.contentDiv[index]['Vfield'].filter(function (e) { return e != null; });

  }
  getFuntionField(fieldList: string | any[], fieldName: string) {

    var feildName = [];
    for (let i = 0; i < fieldList.length; i++) {
      if (fieldList[i].visibleFieldValues.includes(fieldName)) {
        feildName[i] = fieldList[i].name;
      }
    }
    return feildName;
  }

  keyArray(value) {
    this.selectedKeys = [];
    this.selectedKeys.push(value);
    //console.log(this.selectedKeys);
  }
  onItemSelect(item: any) {
    // this.selectedKeys=[];
    //console.log('onItemSelect', item);
    this.selectedKeys.push(item);
    //console.log(this.selectedKeys)
  }
  onItemDeSelect(item: any) {
    var index = this.selectedKeys.indexOf(item);
    if (index !== -1) {
      this.selectedKeys.splice(index, 1);
    }
    //console.log(item);
    //console.log(this.selectedKeys);

  }
  onSelectAll(item: any) {
    //console.log('onSelectAll', item);
  }



  getElementKey(pageName) {
    //console.log(pageName);
    this.elementKeyData = this.locatorData.filter((s) => s.name === pageName); //imp
    //console.log('elementKeyData', this.elementKeyData, pageName)

    this.locatorId = this.elementKeyData[0].id;
    //console.log(this.locatorId);

    // new api
    // this.project.getProjectById(this.projectId).subscribe((
    //   data => {
    //     this.projectData = data;
    //     //console.log(this.projectData);
    //     this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
    //       (data) => {
    //         this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
    //           //console.log(data);
    //         })
    //         this.locatorValueData = data;
    //         //console.log(this.locatorValueData);
    //         // if(this.locatorValueData.locatorEntryMap==null){
    //         //   this.locatorEntryMapValue = {entry:[]} ;
    //         //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         // }
    //         // if(this.locatorValueData.locatorEntryMap!=null){
    //         //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         //   this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
    //         // }
    //         this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         //console.log(this.locatorEntryMapValue);
    //         this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
    //       }
    //     )
    //   }
    // ))

    this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
    //console.log(this.elementEntryKeyData);
  }
  saveChange(testStepUpdateForm) {
    console.log(testStepUpdateForm);
    this.testStepAtSelectedIndex = this.objectForEditTestStep;
    this.testStepAtSelectedIndex['ERValue'] = this.selectedKeys1;
    this.arr = testStepUpdateForm.value;
    this.arr.action
    console.log('arr', this.arr);
    //console.log(this.arr.Action)
    //console.log(this.actions);
    var FilterCommandName = this.actions.filter(f => f.pseAction == this.arr.Action || f.name == this.arr.Action);
    if (FilterCommandName[0]) {
      this.arr.Action = FilterCommandName[0].name
    }
    else {
      //console.log('includes');
      this.toastrService.clear();
      this.toastrService.warning('Select command from the dropdown')
      return;
    }

    if (this.testStepAtSelectedIndex) {
      if (this.arr.actOptions && this.projectId=='rc') {
        this.testStepAtSelectedIndex.commandName = this.arr.actOptions;
      }
      if (this.arr.actOptions && this.projectId!='rc') {
        this.testStepAtSelectedIndex.name = this.arr.actOptions;
      }
      if (this.testStepAtSelectedIndex.name && this.projectId!='rc') {
        this.testStepAtSelectedIndex.name = this.arr.Action;
      }
      else {
        this.testStepAtSelectedIndex.commandName = this.arr.Action;

      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.pageName = this.arr.screenOptions;


        var testScreen = this.locatorData.filter((f) => f.name == this.testStepAtSelectedIndex.pageName);
        //console.log(testScreen);
        if (this.testStepAtSelectedIndex.pageName && testScreen.length < 1) {
          this.toastrService.clear();
          this.toastrService.warning('Select valid name from the dropdown');
          return;
        }
      }
      else {
        this.testStepAtSelectedIndex.pageName = this.arr.Screen;
        var testScreen;
        if (this.locatorData) {
          testScreen = this.locatorData.filter((f) => f.name == this.testStepAtSelectedIndex.pageName);
        }

        if (this.testStepAtSelectedIndex.pageName && testScreen && testScreen.length < 1) {
          this.toastrService.clear();
          this.toastrService.warning('Select valid name from the dropdown');
          return;
        }
      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.elementKey = this.arr.screenOptions;
      }

      this.testStepAtSelectedIndex.parameters['settingValue'] = this.arr.Parameter;
      if (this.testStepAtSelectedIndex.commandName === 'STARTHIGHLIGHT') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.buildStartHighlightRaw();
      } else if (this.testStepAtSelectedIndex.commandName === 'MENUCLICK') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.buildMenuClickRaw();
      } else if (this.testStepAtSelectedIndex.commandName === 'MOVEHIGHLIGHT') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.buildMoveHighlightRaw();
      } else if (this.testStepAtSelectedIndex.commandName === 'CLEARHIGHLIGHT') {
        this.testStepAtSelectedIndex.parameters['settingValue'] = '';
      } else if (this.testStepAtSelectedIndex.commandName === 'WAIT'
          && this.isLeakedStartHighlightJson(this.testStepAtSelectedIndex.parameters['settingValue'])) {
        this.testStepAtSelectedIndex.parameters['settingValue'] = '';
      }
      // //console.log(this.selectedValue);

    }
    if (this.selectedValue === 'Text'
        && this.testStepAtSelectedIndex.commandName !== 'STARTHIGHLIGHT'
        && this.testStepAtSelectedIndex.commandName !== 'MENUCLICK'
        && this.testStepAtSelectedIndex.commandName !== 'MOVEHIGHLIGHT'
        && this.testStepAtSelectedIndex.commandName !== 'CLEARHIGHLIGHT') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.arr.Parameter;
    }
    if (this.selectedAction === 'SEND_KEYS' || this.arr.Action == 'SEND_KEYS') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedKeys.toString() + '&' + this.arr.Parameter;
    }
    if (this.selectedAction === 'HITL' || this.arr.Action=='HITL') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedBranches.join();
      //console.log(this.testStepAtSelectedIndex.parameters);

    }
    if (this.selectedAction === 'INVOKETEST' || this.arr.Action=='INVOKETEST' || this.selectedAction === 'RUN_STEP_BATCH' || this.selectedAction === 'RUNTESTDATA') {
      if(this.selectedCase){
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedCaseId + '&' + this.selectedCase[0].execuationIteration;
      }
     else{
      this.toastrService.clear();
      this.toastrService.warning('Select any case from the list');
      return;
     }
      //console.log(this.testStepAtSelectedIndex.parameters);

    }
    // if (this.selectedAction === 'SET_BUG_LOG_DATA') {
    //   this.testStepAtSelectedIndex.parameters['settingValue'] = JSON.stringify(this.parameterForLogData);
    // }
    if (this.selectedValue === 'Global Variable') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = '$G{' + this.arr.globalValue + '}';

    }

    if (this.selectedValue === 'Function') {
      //console.log(this.arr);
      var functionValue = _.omit(this.arr, ['Action', 'actOptions', 'Screen', 'screenOptions', 'Element', 'elementKey']);
      //console.log(functionValue);

      const myArray = Object.values(functionValue);
      //console.log(myArray);

      // this.testStepAtSelectedIndex.parameters = '${__' + this.contentDiv[index]['methodname'] + '(' + myArray + ')' + '}';
    }
    if (!this.selectedValue) {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.testStepAtSelectedIndex.parameters['settingValue'];
    }
    if (this.contentDiv && this.selectedValue == 'Function' || this.selectedValue == 'Global Variable') {
      //console.log(this.contentDiv);

      var paramName = '';
      for (let i = 0; i < this.contentDiv.length; i++) {

        if (this.contentDiv[i].parameterType == 'Text') {
          paramName = paramName + this.contentDiv[i].parameterValue;

        }
        if (this.contentDiv[i].parameterType == 'Global Variable') {
          paramName = paramName + '$G{' + this.contentDiv[i].parameterValue + '}';
        }

        if (this.contentDiv[i].parameterType == 'Function') {//isKeyValueFunction//isKeyValueFunction
          //console.log(this.contentDiv[i]['methodname']);
          if (this.keyValueFunctions.includes(this.contentDiv[i]['methodname']) || this.contentDiv[i]['isKeyValueFunction']) {
            let result = [];
            var warningMessage = '';
            this.contentDiv[i]['fieldlist'].forEach(data => {
              //console.log(data);

              if (data.isEditable == false && data.value == undefined) {
                data.value = data.defaultValues[0];
              }
              if (data.isMandatory == true && data.name !=='custom-groups') {
                // if(this.selectedSubfunction && data.isMandatory==true && data.isFieldDecideable==true){
                //   data.value = this.selectedSubfunction
                // }
                if (data.value == undefined || data.value == '') {
                  warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                }

              }
              if (data.isMandatory == false) {
                if (data.value == undefined || data.value == '') {
                  data.value = ' ';
                  //console.log(data);

                }

              }


              let result1 = data.name + "=" + data.value;
              result.push(result1);



            });

            if (warningMessage && warningMessage.length > 0) {
              // warningMessage = $scope.toCamelCase(warningMessage);
              this.toastrService.clear();
              this.toastrService.warning(warningMessage, null, {
                enableHtml: true
              });
              return;
            }
            let finalValue = result.join();
            paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //console.log(paramName);
            if (this.contentDiv[i]['result4']) {
              //console.log(this.contentDiv[i]['result4']);
              let varResult = []
              for (let j = 0; j < this.contentDiv[i]['result4'].length; j++) {
                this.contentDiv[i]['result4'][j].forEach(data1 => {

                  let varResult1 = data1.value;

                  varResult.push(varResult1);

                });
              }

              //console.log(varResult);

              let finaleValueOfVarFunc = varResult.join(',');

              //console.log(finaleValueOfVarFunc);

              //console.log('final',finaleValueOfVarFunc);


              paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ',' + finaleValueOfVarFunc + ')}';
            }
          }
          else {
            let result = [];
            var warningMessage = '';
            this.contentDiv[i]['fieldlist'].forEach(data => {
              //console.log(data);

              if (data.isEditable == false && data.value == undefined) {
                data.value = data.defaultValues[0];
              }

              if (data.isMandatory == true && data.name !=='custom-groups') {
                if (data.value == undefined || data.value == '') {
                  warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                }

              }
              if (data.isMandatory == false || data.value == '') {
                if (data.value == undefined) {
                  data.value = ' ';
                  //console.log(data);

                }

              }

              let result1 = data.value;
              result.push(result1);

            });
            if (warningMessage && warningMessage.length > 0) {
              // warningMessage = $scope.toCamelCase(warningMessage);
              this.toastrService.clear();
              this.toastrService.warning(warningMessage, null, {
                enableHtml: true
              });
              return;
            }
            let finalValue = result.join();
            paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //console.log(paramName);
            if (this.contentDiv[i]['result4']) {
              //console.log(this.contentDiv[i]['result4'][i]);
              let varResult = []
              for (let j = 0; j < this.contentDiv[i]['result4'].length; j++) {
                this.contentDiv[i]['result4'][j].forEach(data1 => {
                  if (data1.value != undefined) {
                    let varResult1 = data1.value;
                    varResult.push(varResult1);
                  }
                });
              }
              let finaleValueOfVarFunc = varResult.join(',');
              console.log('final', finaleValueOfVarFunc);


              paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ',' + finaleValueOfVarFunc + ')}';
            }
          }


          // //console.log(this.contentDiv[i]['parameterArg']);
          // if (this.contentDiv[i]['parameterArg']) {
          //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
          //   //console.log('result1', this.contentDiv[i]['result1']);

          //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
          //   }

          // }
          // else {
          //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   //console.log('result1', this.contentDiv[i]['result1']);
          //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
          //   }
          // }

          // if (this.contentDiv[i]['isKeyValueFunction']) {
          //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
          //     this.contentDiv[i]['result2'].forEach((value, index2) => {
          //       //console.log(index1, index2)
          //       if (index1 == index2) {
          //         let obj = { 'name': element, 'value': value }
          //         if(!this.contentDiv[i]['result3'])
          //         {
          //           this.contentDiv[i]['result3'] = [];
          //           this.contentDiv[i]['result3'].push(obj);
          //         }
          //         this.contentDiv[i]['result3'].push(obj);
          //       }
          //     });
          //   });

          //   let result = [];
          //   this.contentDiv[i]['result3'].forEach(data => {
          //     let result1 = data.name + "=" + data.value;
          //     result.push(result1);
          //   });

          // let finalValue = result.join();
          // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
          // //console.log(paramName);



          // else {

          // //console.log(this.contentDiv[i].parameterValue);

          //   let result = [];
          //   this.contentDiv[i]['fieldlist'].forEach(data => {
          //     let result1 = data.value;
          //     result.push(result1);
          //   });
          //   let finalValue = result.join();
          //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
          //     //console.log(paramName);

          //   // //console.log(this.contentDiv[i]['parameterArg']);
          //   // if (this.contentDiv[i]['parameterArg']) {
          //   //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
          //   //   //console.log('result1', this.contentDiv[i]['result1']);

          //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //   //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
          //   //   }

          //   // }
          //   // else {
          //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   //   //console.log('result1', this.contentDiv[i]['result1']);
          //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //   //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
          //   //   }
          //   // }

          //   // if (this.contentDiv[i]['isKeyValueFunction']) {
          //   //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
          //   //     this.contentDiv[i]['result2'].forEach((value, index2) => {
          //   //       //console.log(index1, index2)
          //   //       if (index1 == index2) {
          //   //         let obj = { 'name': element, 'value': value }
          //   //         if(!this.contentDiv[i]['result3'])
          //   //         {
          //   //           this.contentDiv[i]['result3'] = [];
          //   //           this.contentDiv[i]['result3'].push(obj);
          //   //         }
          //   //         this.contentDiv[i]['result3'].push(obj);
          //   //       }
          //   //     });
          //   //   });

          //   //   let result = [];
          //   //   this.contentDiv[i]['result3'].forEach(data => {
          //   //     let result1 = data.name + "=" + data.value;
          //   //     result.push(result1);
          //   //   });

          //     // let finalValue = result.join();
          //     // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
          //     // //console.log(paramName);
          //     if(this.contentDiv[i]['result4']){
          //     //console.log(this.contentDiv[i]['result4'][i]);
          //     let varResult = []
          //     this.contentDiv[i]['result4'][i].forEach(data1 => {

          //       let varResult1 = data1.name + "=" + data1.value;
          //       varResult.push(varResult1);
          //     });
          //     let finaleValueOfVarFunc = varResult.join();
          //     //console.log('final',finaleValueOfVarFunc);


          //       paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue +','+ finaleValueOfVarFunc + ')}';
          //   }


          // }

          // }

        }




      }


      // //console.log("final result3");


      if (this.contentDiv[0]['parameterType'] != undefined
          && this.testStepAtSelectedIndex.commandName !== 'STARTHIGHLIGHT'
          && this.testStepAtSelectedIndex.commandName !== 'MENUCLICK'
          && this.testStepAtSelectedIndex.commandName !== 'MOVEHIGHLIGHT'
          && this.testStepAtSelectedIndex.commandName !== 'CLEARHIGHLIGHT') {
        //console.log(this.contentDiv);

        this.testStepAtSelectedIndex.parameters['settingValue'] = paramName;
      }

      //console.log('param', paramName);

    }

    if (this.testStepAtSelectedIndex.commandName === 'STARTHIGHLIGHT') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.buildStartHighlightRaw();
    } else if (this.testStepAtSelectedIndex.commandName === 'MENUCLICK') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.buildMenuClickRaw();
    } else if (this.testStepAtSelectedIndex.commandName === 'MOVEHIGHLIGHT') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.buildMoveHighlightRaw();
    } else if (this.testStepAtSelectedIndex.commandName === 'CLEARHIGHLIGHT') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = '';
    }

    this.testStepAtSelectedIndex.elementKey = this.arr.Element;
if(this.BranchName){
  this.testStepdataBranch.teststepList[this.stepIndexTobeEdit] = this.testStepAtSelectedIndex
  // this.testStepdataBranch.teststepList.forEach(function (v) {
  //   if (v.parentNestedBlock) {
  //     delete v.parentNestedBlock
  //   }
  // });
  this.updateBranchSteps();
}
else{
  if(this.projectId=='rc'){
    this.testStep[this.stepIndexTobeEdit] = this.testStepAtSelectedIndex
  }
  else{
    this.testStepdata.teststepList[this.stepIndexTobeEdit] = this.testStepAtSelectedIndex
  }
  
  // this.testStepdata.tetstepList.forEach(function (v) {
  //   if (v.parentNestedBlock) {
  //     delete v.parentNestedBlock
  //   }
  // });
  if(this.isER){
    let currentValue = this.testStepdata.teststepList[this.stepIndexTobeEdit].parameters['settingValue'];
    const parts = currentValue.split(',');
    const lastCommaIndex = currentValue.lastIndexOf(',', currentValue.lastIndexOf(')}'));
    const baseString = parts.slice(0, 3).join(',') + ',';
    const newValue = baseString + this.selectedKeys2.toString() + ')}';
    this.testStepdata.teststepList[this.stepIndexTobeEdit].parameters.settingValue = newValue;
    this.isER = false;
    this.selectedKeys2 = [];
    this.selectedKeys1 = [];

    }
  this.updateTestStepByIndex();
}
    
  }
  updateTestStepByIndex() {
   
    const updateTestStepData = this.testStepdata;
    //console.log(updateTestStepData);
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
    if(this.projectId!='rc'){
    this.testCase.editTestCase(this.projectId, this.testId, myFinalObject).
      subscribe((data) => {
        if (data) {
          console.log("upDateData", data);
          this.testStep = data.teststepList
          for (let i = 0; i < this.testStep.length; i++) {
            // this.testStep[i] = {
            //    stepIndex:''
            //   }
            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;

          }
          this.visibleIndexForCardTip = this.testStep.length
          this.testCase.shareTestSteps(this.testStep);
          // this.loadFlowchart(this.testStep);
          this.toastrService.clear();
          this.toastrService.success('Edited successFully')

        }
      });
    }
    if(this.projectId=='rc'){
      this.updateRc(this.currentRcForUpdate.children.componentName,this.currentRcForUpdate.children.accessType,this.rcCat,this.testStep,this.rcId)
      
    }
  }
  getBranchSteps(id){
    this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + id).
    subscribe(
      (data) => {

        this.testStepdataBranch = data;
        return this.testStepdataBranch;
      })
  }
  updateBranchSteps(){
    
        const updateTestStepData = this.testStepdataBranch;
    //console.log(updateTestStepData);
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
    this.testCase.editTestCase(this.projectId, this.testId, myFinalObject).
      subscribe((data) => {
        if (data) {
          console.log("upDateData", data);
          this.testStep = data.teststepList
     
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {
              // sessionStorage.clear();
              // localStorage.clear();
              this.testStepdata = data;
              // this.indexFormArray = undefined
              // for (let i = 0; i < removeArray.length; i++) {
              //   this.onChange(removeArray[i], false);
              // }
              this.testCase.setSelectedData([]);
              this.dropDataService.selectAllSteps.next(false);
              setTimeout(() => {
               
                  this.toastrService.clear();
                  this.toastrService.success('Selected  Card Edited successfully');
                
            
                if (this.testStepdata['teststepList']) {
                  // removeArray = [];
                  this.testStep = [];
                  this.testStep = this.testStepdata.teststepList;
                  this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    // ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  // this.loadFlowchart(this.testStep);
                  this.loadTestStepData = false;
                  // this.getIncludedTestCases();
                }
                else {
                  this.testStepCopy = [];
                  this.testStep = [];
                  // this.loadFlowchart(this.testStep);
                }
                this.testCase.shareTestSteps(this.testStep);
              }, 100);



            }
          )

        }
      });
  
   
  }
  loadFlowchart(testStep: any) {
    throw new Error('Method not implemented.');
  }
  onChangeFunctionDropdown(value, name, isFieldDecideable, index, defaultValues?: any) {
    //console.log('insideDropDown');
    console.log('defaultValues', defaultValues, value, name, isFieldDecideable);
    // if(defaultValues){
    //   var description = defaultValues.filter((f) => f.name ===value);
    //   console.log('description',description[0].description);
    //   this.functionDescription = description[0].description;
    // }else{
    //   this.functionDescription = ''
    // }

    // this.testStepAtSelectedIndex['functionDescription'] = this.functionDescription;

    //TODO: need to change this hack
    if (!isFieldDecideable) {
      return;
    }
    if (name === 'overwrite' && this.currentFunction.name === 'FILEHANDLER') {
      return;
    }
    if (name === 'track' && this.currentFunction.name === 'FILEHANDLER') {
      return;
    }


    // this.currentFunction.fieldList = this.contentDiv[index]['fieldlist'];
    var matchingElements = this.getMatchingFields(JSON.parse(JSON.stringify(this.currentFunction.fieldList)), name);
    //var matchingElements = this.currentFunction.fieldList.filter(o => o.visibleFieldName === name);
    var matchingValues = [];
    if (matchingElements.length > 0) {
      matchingValues = this.getMatchingValues(matchingElements, value);
      console.log(matchingValues);

      matchingValues.splice(0, 0, this.getFuntionField1(this.currentFunction.fieldList, name));// Add the current field at index 0
      this.contentDiv[index]['fieldlist'] = matchingValues;
      //console.log(this.contentDiv[index]['fieldlist']);
      JSON.parse(JSON.stringify(this.currentFunction.fieldList))
      // if ($scope.testStepObj.parametersForms) {
      //     $scope.testStepObj.parametersForms[0].args = new Array();
      //     $scope.testStepObj.parametersForms[0].args.push(value);
      // }
      // $scope.onSelectionChanges($scope.testStepObj);
    }
    if (this.currentFunction.type === 'variable' && this.currentFunction.variableFieldList && this.currentFunction.variableFieldList.length > 0) {
      // this.currentFunction.variableFieldList = angular.copy($scope.originalVaribaleFieldList);
      var matchingElements = [];
      for (var i = 0; i < this.currentFunction.variableFieldList.length; i++) {
        if (this.currentFunction.variableFieldList[i].visibleFieldName === name) {
          if (this.currentFunction.variableFieldList[i].visibleFieldValues.includes(value)) {
            this.currentFunction.variableFieldList[i].isVisible = true;
            matchingElements.push(this.currentFunction.variableFieldList[i]);
          }
        }
      }
      this.currentFunction.variableFieldList = matchingElements;
    }

  };
  getMatchingFields(fieldList, fieldName) {
    var matchingElements = [];
    for (var i = 0; i < fieldList.length; i++) {
      if (fieldList[i].visibleFieldName === fieldName) {
        matchingElements.push(fieldList[i]);
      }
    }
    return matchingElements;
  }

  getMatchingValues(matchingElements, value) {
    var matchingValues = [];
    for (var i = 0; i < matchingElements.length; i++) {
      if (matchingElements[i].visibleFieldValues.includes(value)) {
        matchingElements[i].isVisible = true;
        matchingValues.push(matchingElements[i]);
      }
    }
    return matchingValues;
  }

  getFuntionField1(fieldList, fieldName) {
    var matchingField;
    for (var i = 0; i < fieldList.length; i++) {
      if (fieldList[i].name === fieldName) {
        matchingField = fieldList[i];
        break;
      }
    }
    return matchingField;

  }

  checkIfFunctionMethodNameExist(methodName) {
    //   var functionMethodNames = {}
    //   for (var i = 0; i < this.functions.length; i++) {
    //     // if(typeof(data.list[i]) == 'string' && JSON.parse(data.list[i])){
    //     var obj = JSON.parse(this.functions[i]);
    //     //console.log("objcheck", obj);
    //    functionMethodNames[obj.method] = obj.method;
    //   // }
    // }
    //   if (functionMethodNames[methodName]) {
    //       return true;
    //   }
    //   return false;
    var isExist = this.functions.find((f) => f.method == methodName);
    if (isExist) {
      return true
    }
    return false;
  }

  onCreateScreen() {
    if (this.editLocatorTitleForm.invalid) {
      return;
    }
    var objFormval = this.editLocatorTitleForm.value;
    console
    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }
    var Objval;
    if(this.projectId!='rc'){
      Objval = {
        name: objFormval.name,
        projectId: this.projectId
      }
    }
    else{
      Objval = {
        name: objFormval.name,
        componentId: this.rcId
      }
    }
   

    this.project.addScreen(Objval).subscribe((data) => {
      if (data) {
        console.log("Test123 : ", data);
        this.locatorManagementCheck = false;
        this.getLocator();
        this.toastrService.clear();
        this.toastrService.success(' New screen added successfully');
        if(this.projectId!='rc'){
          this.project.sendLocatorData(this.projectId);
        }
        else{
          this.project.sendLocatorData(this.rcId);
        }

      }

    });

  }
  getLocator() {
    if(this.projectId!='rc'){
      this.testCase.getLocatorSuite(this.projectId).subscribe(
        (data) => {
          console.log("Test123 : ", data);
          this.locatorData = data['locatorSuite'];
          ////"locatorsuit>>",data);
          setTimeout(() => {
            // this.getHighLight();
          }, 0);
        }
      )  
    }
    else{
      this.testCase.getLocatorSuite(this.rcId).subscribe(
        (data) => {
          console.log("Test123 : ", data);
          this.locatorData = data['locatorSuite'];
          ////"locatorsuit>>",data);
          setTimeout(() => {
            // this.getHighLight();
          }, 0);
        }
      )
    }

  

  }

  changeTab(isElementKey: boolean, screenName: string) {
    this.selectedScreenName = screenName;
    this.editLocatorTitleForm.reset();
    if (isElementKey) {
      this.editLocatorTitleForm.patchValue({ name: screenName })
    }
  }

  // selectChangeScreen(event: any) {
  //   this.selectedScreen = event;
  //   // this.selectedScreen.substring(3);
  //   this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen); //imp
  //   this.locatorId = this.elementKeyData[0].id;
  //   this.project.getProjectById(this.projectId).subscribe((
  //     data => {
  //       this.projectData = data;
  //       this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
  //         (data) => {
  //           this.locatorValueData = data;
  //           this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
  //           this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
  //         }
  //       )
  //     }
  //   ))
  //   this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
  // }
  selectChangeScreen(event: any) {

    // //console.log("event : ",event);
    // //console.log(event.target.value);
    // //console.log(this.testStep);
    // //console.log(this.locatorData);
    this.selectedScreen = event;


    this.selectedScreen.substring(3);
    // //console.log('selectedScreen',this.selectedScreen);
    // this.getLocator();
    this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen); //imp
    // this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
    if(this.locatorData[0].locatorEntryMap==null){
      this.locatorData[0].locatorEntryMap = {entry:[]}
    }
    //console.log('elementKeyData', this.elementKeyData, this.selectedScreen)

    this.locatorId = this.elementKeyData[0].id;
    //console.log(this.locatorId);

    // new api
    if(!JSON.parse(localStorage.getItem('projectDataById'))){
      
    this.project.getProjectById(this.projectId).subscribe((
      data => {
        this.projectData = data;
        //console.log(this.projectData);
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
              //console.log(data);
            })
            this.locatorValueData = data;
            console.log(this.locatorValueData);
            if(this.locatorValueData.locatorEntryMap==null){
              this.locatorEntryMapValue = {entry:[]} ;
              this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
            }
            
            if(this.locatorValueData.locatorEntryMap!=null){
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //console.log(this.locatorEntryMapValue);
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap?.entry;
            this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
          }
          
        )
      }
    ))
    }
    else if(JSON.parse(localStorage.getItem('projectDataById'))){
      
      var res = JSON.parse(localStorage.getItem('projectDataById'));
          this.projectData = res;
          //console.log(this.projectData);
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
                //console.log(data);
              })
              this.locatorValueData = data;
            console.log(this.locatorValueData);
            if(this.locatorValueData.locatorEntryMap==null){
              this.locatorEntryMapValue = {entry:[]} ;
              this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
            }
            
            if(this.locatorValueData.locatorEntryMap!=null){
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              if(this.locatorValueData.locatorCommentMap==null){
                this.locatorCommentMap = {entry:[]} ;
                this.locatorValueData.locatorCommentMap = this.locatorCommentMap;
              }
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //console.log(this.locatorEntryMapValue);
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap?.entry;
            this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
            }
          
          )
      
      }
    
    //console.log(this.elementEntryKeyData);
  }

  delLocator(values) {
    this.confirmationDialogService.openConfirmDialog('Are you sure to delete ' + values + ' ?')
      .afterClosed().subscribe(res => {
        console.log("Test123 : ", res);
        if (res) {
          const valueForDelete = this.locatorEntryMapValue.filter((f) => f.key == values);

          this.locatorEntryMapValue.forEach((element, index) => {
            if (element == valueForDelete[0]) this.locatorEntryMapValue.splice(index, 1);
          });
          var functionValue = _.omit(this.locatorValueData, ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited', 'path']);
          this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
            (data: any) => {
              console.log("Test123 : ", data);
              var d = data['locatorSuite'][0].name;
              this.testCase.getLocatorSuite(this.projectId).subscribe(
                (element) => {
                  console.log("Test123 : ", element);
                  this.locatorData = element['locatorSuite'];
                  this.loadElements(d);
                }
              )
              this.toastrService.clear();
              this.toastrService.success(' locator deleted successfully');
              this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
                (data) => {
                  console.log("Test123 : ", data);
                  this.locatorValueData = data;
                  this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
                  this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
                  this.addLocatorsForm.reset();
                }
              )
            }
          )
        }
      })
  }

  insertLocatorComment(key) {
    this.keyForinsertComment = key;
    if (this.locatorEntryCommentValue == undefined) {
      this.valueForUpdate1 = 'Enter Comment';
      return;
    }
    this.valueForInsert = this.locatorEntryCommentValue.filter((f) => f.key == this.keyForinsertComment);
    this.valueForUpdate1 = this.valueForInsert[0] ? this.valueForInsert[0].value : undefined;
    if (this.valueForUpdate1 == undefined) {
      this.valueForUpdate1 = 'Enter Comment'
    }
    if (this.valueForUpdate1 == "") {
      this.valueForUpdate1 = 'Enter Comment'
    }
  }
  updateLocator(index, rowData) {
    console.log(rowData);
    this.locatorValueIndex = index;
    this.updateLocatorsForm.patchValue({ 'key': rowData.key, 'value': rowData.value, 'comment': this.valueForUpdate1 });
  }

  onAddLocators() {

    if (this.addLocatorsForm.invalid) {
      return;
    }
    this.addLocatorsForm.value.key = this.addLocatorsForm.value.key.trim();
    this.addLocatorsForm.value.value = this.addLocatorsForm.value.value.trim();
    var objFormval1 = this.addLocatorsForm.value;
    if (this.locatorEntryMapValue) {

      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      const objForCommentMap =
      {
        key: objFormval1.key,
        value: objFormval1.comment
      }

      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Values Are Not Allowed ');
        return;
      }
      const compareKeyValue = this.locatorValueData.locatorEntryMap.entry.filter((f) => f.key == objForCommentMap.key);
      if (compareKeyValue[0]) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
        return;
      }
      this.locatorEntryMapValue.unshift(objFormval1);
      if (this.locatorValueData.locatorCommentMap) {
        this.locatorValueData.locatorCommentMap.entry.unshift(objForCommentMap);
      }
      else {
        let data =
        {
          entry: []
        }
        data.entry.push(objForCommentMap);
        this.locatorValueData.locatorCommentMap = data;
      }
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data: any) => {
          console.log("Test123 : ", data);
          this.cancelAddLocator.nativeElement.click();
          // var d = data['locatorSuite'][0].name;
          this.testCase.getLocatorSuite(this.projectId).subscribe(
            (element) => {
              console.log("Test123 : ", element);
              this.locatorData = element['locatorSuite'];
              this.loadElements(this.selectedScreenName);
            }
          )
          this.getLocator();
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          this.cancelAddLocator.nativeElement.click();
          this.initForms();
        }
      )
    }
    else {

      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        //console.log('Empty key Are Not Allowed');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Value Are Not Allowed ');
        //console.log('Empty Value Are Not Allowed');

        return;
      }
      if (objFormval1.comment == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Comment Are Not Allowed ');
        //console.log('Empty comment Are Not Allowed');
        return;
      }
      this.locatorEntryMapValue = { entry: [] };
      this.locatorValueData.locatorCommentMap = {
        entry: [
          {
            key: objFormval1.key,
            value: objFormval1.comment
          }
        ]
      }
      this.locatorEntryMapValue.entry.unshift(objFormval1);
      this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data: any) => {
          console.log("Test123 : ", data);
          this.cancelAddLocator.nativeElement.click();
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          var d = data.name;
          this.testCase.getLocatorSuite(this.projectId).subscribe(
            (element) => {
              console.log("Test123 : ", element);
              this.locatorData = element['locatorSuite'];
              this.loadElements(d);
            }
          )
          this.cancelAddLocator.nativeElement.click();
          this.initForms();
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              console.log("Test123 : ", data);
              this.locatorValueData = data;
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
              this.getLocator();
            }
          )
        }
      )
    }

  }
  moveTestStepForm: UntypedFormGroup;
  initForms() {
    this.moveTestStepForm = this.formBuilder.group({
      orderIndex: ['', [Validators.required, Validators.min(1)]]
    })

    this.editLocatorTitleForm = this.formBuilder.group({
      name: ['', [Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/), Validators.required]],
    })

    this.addLocatorsForm = this.formBuilder.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      comment: ['']
    })

    this.updateLocatorsForm = this.formBuilder.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      comment: ['']
    })
  }

  loadElements(data) {
    this.selectedScreen = data
    // this.selectedScreen.substring(3);
    this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen);

    this.locatorId = this.elementKeyData[0].id;

    this.project.getProjectById(this.projectId).subscribe((
      data => {
        this.projectData = data;
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            console.log("Test123 : ", data);
            this.locatorValueData = data;
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
          }
        )
      }
    ))

    this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
  }

  submitUpdateLocatorForm() {
    if (this.updateLocatorsForm.invalid) {
      return;
    }
    this.updateLocatorsForm.value.key = this.updateLocatorsForm.value.key.trim();
    this.updateLocatorsForm.value.value = this.updateLocatorsForm.value.value.trim();
    var objFormval = this.updateLocatorsForm.value;
    let screenNameData = this.locatorData.filter((data) => data.name == this.selectedScreen)
    screenNameData[0].locatorEntryMap.entry[this.locatorValueIndex] = objFormval;
    screenNameData[0].locatorCommentMap = {
      entry: [
        {
          key: objFormval.key,
          value: objFormval.comment
        }
      ]
    }
    var functionValue = _.omit(screenNameData[0], ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited', 'path']);
    
    const compareKeyValue = functionValue.locatorEntryMap.entry.filter((f) => f.key == objFormval.key);

    if (compareKeyValue[1]) {
      this.toastrService.clear();
      this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
      return;
    }

    this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
      (data) => {
        console.log("Test123 : ", data);
        this.locatorValueData = data['locatorSuite'][0];
        this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
        this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
        var d = data['locatorSuite'][0].name;
        this.loadElements(d);
        this.toastrService.clear();
        this.toastrService.success('Locator data updated successfully');
        this.initForms();
        this.cancelUpdateLocator.nativeElement.click();
      })
  }
  addRow(commandName: string, id?: any) {
    this.testStepAtSelectedIndex = {
      active: "ENABLE",
      commandName: "",
      comment: "",
      runtimeData: 'false',
      debug: "",
      elementKey: "",
      evaluatedMetaValue: "",
      maskedData: "",
      pageName: "",
      parameters: {
        settingValue: '',
        isMasked: 'false'
      },
      result:
      {
        startTime: '0', endTime: '0', duration: '0.0',
        resultState:
        {

        },
        aggrResultState: {

        },
      },
      runState: "",
      testData: "",
      type: "AUTOMATIC",
    }
    if (this.testCaseType == 'MANUAL') {
      this.testStepAtSelectedIndex.type = 'MANUAL';
    }
    // this.testStepAtSelectedIndex = this.testStep[0];
    ////"formTestStep", this.testStepAtSelectedIndex);
    if (commandName) {
      this.testStepAtSelectedIndex.commandName = commandName;
    }
    else {
      if (this.projectType === 'WEB') {
        this.testStepAtSelectedIndex.commandName = 'OPEN';
      } else if (this.projectType === 'DESKTOP') {
        this.testStepAtSelectedIndex.commandName = 'OPENDESKTOPAPP';
      } else if (this.projectType === 'MOBILE') {
        this.testStepAtSelectedIndex.commandName = 'OPENMOBILEAPP';
      } else if (this.projectType === 'MIXED') {
        this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
      }
      else if (this.projectType === 'REST') {
        this.testStepAtSelectedIndex.commandName = 'REQ_START';
      }
      else {
        this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
      }
    }
    // this.arr = testStepUpdateForm.value;


    // this.testStepAtSelectedIndex.commandName = 'OPEN';
    this.testStep = [];
    // this.testStep = this.testStepdata.teststepList;
    const items = this.testStep;
    ////items);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]

    const result = insert(items, 0, this.testStepAtSelectedIndex)


    this.testStepdata.teststepList = result;
    ////"Create", result);
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    if(this.projectId!='rc'){
      this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.checkAllTestSteps = false;
          this.testStepdata = data;
          this.testCaseType = this.testStepdata.testCaseType
          if(this.testStepdata['teststepList'])
          {
            this.testStep = this.testStepdata.teststepList;
            localStorage.setItem('localData',JSON.stringify(this.testStep))
          }
                this.testStep = [];
                this.testStep = this.testStepdata.teststepList;
                for (let i = 0; i < this.testStep.length; i++) {
                  // this.testStep[i] = {
                  //    stepIndex:''
                  //   }
                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
  
                }
               this.editEnable(this.testStep[0])
                  // this.testCase.shareTestSteps(this.testStep);
                  let flowchartView = { "root": this.convertTableToFlowchart(this.testStep), "connectors": [] };
                  this.sampleJson = flowchartView;
                  this.showUpload();
               

          ////item);
          ////'Updaaateee')
         
          ////authCheck);
          
          console.log('DataAddR', this.testStepdata);
          // teststepList
          
        }
      });
    }
   
      if(this.projectId=='rc'){
        this.updateRc(this.currentRcForUpdate.children.componentName,this.currentRcForUpdate.children.accessType,this.rcCat,this.testStepdata.teststepList,this.rcId)
        }
    
   
  }
  openmenu() {
    var x = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      $('.hl-actionWrapper').removeClass('show');
      x.style.display = "block";

    }
    else {
      x.style.display = "block";
    }
  }
  closemenu() {
    var x = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      x.style.display = "block";
    }
    else {
      x.style.display = "none";
    }
  }

  openRCMenu() {
    var x = document.getElementById("dropdown2");
    if (x.style.display === "none") {
      $('.h2-actionWrapper').removeClass('show');
      x.style.display = "block";

    }
    else {
      x.style.display = "block";
    }
  }
  closeRCMenu() {
    var x = document.getElementById("dropdown2");
    this.selectedRc = undefined
    if (x.style.display === "none") {
      x.style.display = "block";
    }
    else {
      x.style.display = "none";
    }
  }

  searchAction(value?:string) {
    // this.globalSearch;
    this.groupedActionDataCopy = JSON.parse(JSON.stringify(this.groupedActionData))
    this.groupedActionDataCopy1 = JSON.parse(JSON.stringify(this.groupedActionData))
    this.showSuggestion = true;
    //);
    if (this.globalSearch && this.globalSearch.trim().length === 0) {
      this.groupedActionDataCopy = this.groupedActionDataCopy1
      this.showSuggestion = false;
      return;
    }
    var searchArray = []
    this.groupedActionDataCopy.forEach((element, i) => {
      if (this.globalSearch && element.groupName.toLowerCase().includes(this.globalSearch.toLowerCase())) {

        searchArray.push(element);
      }
      element.children.forEach((element1, j) => {

        if (element1.type != 'sub') {
          if (element1.name.toLowerCase().includes(this.globalSearch?.toLowerCase())) {

            searchArray.push(element);
          }
        }
        if (element1.type == 'sub') {
          element1.subfunction.forEach(elementSub => {
            if (elementSub.name.toLowerCase().includes(this.globalSearch?.toLowerCase())) {

              searchArray.push(element);
            }
          });

        }
      });
    });
    if(value.trim().length>0){
      this.groupedActionDataCopy = this.urlService.removeDuplicates(searchArray);
      // this.groupedActionDataCopy.forEach((element, i) => {
      //   element.groupColor = '#002d5b';
      //   element.children.forEach(elementChild => {
      //     let palette:any = {};
      //     let steps = {};
      //     let data = {
      //     };
        
      //     elementChild.color = element.groupColor;
      //     elementChild.icon = element.groupIcon;
      //     elementChild.icon = element.groupIcon;
      //     if(elementChild.type == 'action'){
            
      //       if(elementChild.children.name=='HITL'){
      //         data['commandName'] = elementChild.children.name;
      //         data['desc'] = elementChild.children.desc;
      //         data['testStepId'] = this.testStepId;
      //         data['projectId'] = this.projectId;
      //         data['index'] = 1;
      //         steps['template'] = FormStepComponent;
      //         steps['data'] = data;
      //         steps['type'] = 'form-step1',
      //         palette['paletteName'] = elementChild.children.name;
      //         palette['step'] = steps;
      //         elementChild['customOps']= palette;
      //       }
      //       else{
      //         data['commandName'] = elementChild.children.name;
      //       data['desc'] = elementChild.children.desc;
      //       data['testStepId'] = this.testStepId;
      //       data['projectId'] = this.projectId;
      //       data['index'] = 1;
      //       steps['template'] = FormStep1Component;
      //       steps['data'] = data;
      //       steps['type'] = 'form-step1',
      //       palette['paletteName'] = elementChild.children.name;
      //       palette['step'] = steps;
      //       elementChild['customOps']= palette;
      //       }
      //     }
        
      //     if (elementChild.type == 'fun') {
      //       data['commandName'] = 'SET';
      //       data['desc'] = elementChild.function.description;
      //       data['testStepId'] = this.testStepId;
      //       data['projectId'] = this.projectId;
      //       data['index'] = 1;
      //       steps['template'] = FormStep1Component;
      //       steps['data'] = data;
      //       steps['type'] = 'form-step1',
      //       palette['paletteName'] = elementChild.name;
      //       palette['step'] = steps;
      //       elementChild['customOps']= palette;
      //       // elementChild.subfunction.forEach(elementSub => {
      //       //   elementSub.color = element.groupColor;
      //       //   elementSub.icon = element.groupIcon;
             
      //       //   // element.icon = Icons[i]
      //       // });
      //     }
        
      //   });
      // });
    }
   else{
    this.groupedActionDataCopy = this.groupedActionDataCopy1;
   }


  }

  openGroupedAction(groupName) {
    this.groupNameDis = groupName
    this.clubbedActions = this.groupedActionData.filter((f) => f.groupName == groupName);
    this.actionsFilter = this.clubbedActions[0].children;
    $('.hl-chooseCatogeryWrapper').removeClass('show');
    $('.hl-actionWrapper').addClass('show');
    this.closemenu();
  }

  openRCCategory(category)
  {
    this.selectedRCCategory = category.children
    $('.h2-chooseCatogeryWrapper').removeClass('show');
    $('.h2-actionWrapper').addClass('show');
    this.closeRCMenu();
  }
  openChild(category){
    this.selectedRc = category;
    this.enableChild = !this.enableChild
  }
  
  showSubfunctions(action) {
    //action);
    this.subFunctionType = action['type'];
    this.ActionName = action.name
    this.subFunctionsCollections = action.subfunction;
    this.subFunctionsCollections['type'] = action['type'];
    this.showSubFunctionFlag = !this.showSubFunctionFlag;
  }
  showDropdown() {
    this.showSubFunctionFlag = false;
    // $('.hl-actionWrapper').removeClass('show');
    // if(this.cardViewType == 'Horizontal')
    // {
    //   $('.hl-miniMap').addClass('margin-left-horizontal-chart');
    // }
    // $('.hl-chooseCatogeryWrapper').addClass('show');
    var x = document.getElementById("dropdown2");
    var y = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      $('.hl-chooseCatogeryWrapper').addClass('show');
      x.style.display = "block";
      y.style.display = "none";
    }

    else {
      x.style.display = "block";
    }
    this.globalSearch = undefined;
    this.searchAction();
  }
  closeDropdown() {
    $('.hl-miniMap').removeClass('margin-left-horizontal-chart');
    $('.hl-chooseCatogeryWrapper').removeClass('show');
    this.globalSearch = undefined;
    this.searchAction()
  }
  showCategory() {
    $('.hl-chooseCatogeryWrapper').removeClass('show');
    $('.hl-actionWrapper').addClass('show');
  }

  closeCatDropdown() {
    $('.hl-actionWrapper').removeClass('show');
    $('.hl-miniMap').removeClass('margin-left-horizontal-chart');
    this.globalSearch = undefined;
    this.searchAction();
  }

  closeRCCatDropdown() {
    $('.h2-actionWrapper').removeClass('show');
    $('.h2-miniMap').removeClass('margin-left-horizontal-chart');
  }

  getSelectedSteps(){

    var selectedStepIndex = []
    this.selectedSteps.forEach(element => {
      selectedStepIndex.push(element.stepIndex)
    });
    this.selectedIndexArray = selectedStepIndex
    this.removeSelectedRows()
  }

  removeSelectedRows() {

    if (this.selectedIndexArray === undefined) {
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to delete');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to delete');
      }
      ////'udefined',this.indexFormArray);

      return;
    }
    else if (this.selectedIndexArray.length < 1) {
      ////'empty',this.indexFormArray.value);
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to delete');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to delete');
      }
      return;
    }
    else if (this.selectedIndexArray.length > 0) {
      ////'empty',this.indexFormArray.value);
      let removeArray = this.selectedIndexArray;

      removeArray = removeArray.sort((a, b) => a - b);
      let testStepCopy = JSON.parse(JSON.stringify(this.testStep));
      for (let i = 0; i < removeArray.length; i++) {
        var temp;
        removeArray[i];
        temp = removeArray[i];
        ////temp);
        testStepCopy[temp] = {};
      }
      let testStep = testStepCopy.filter(value => JSON.stringify(value) !== '{}');
      ////this.testStep);
      this.testStepdata.teststepList = testStep
      // this.testStepdata.teststepList.filter(value => JSON.stringify(value) !== '{}');
      ////this.testStepdata);
      this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete selected steps ?')
        .afterClosed().subscribe(res => {
          console.log("Test123 : ", res);
          if (res) {
            this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
              subscribe((data) => {
                if (data) {
                  this.testCase.setSelectedData([]);
                  this.dropDataService.selectAllSteps.next(false);
                  this.stepOptions = undefined;
                  // ////"upDateData", data);
                  this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                    subscribe(
                      (data) => {
                        // sessionStorage.clear();
                        // localStorage.clear();
                        this.testStepdata = data;
                        this.testCaseType = this.testStepdata.testCaseType
                        // this.indexFormArray = undefined
                        // for (let i = 0; i < removeArray.length; i++) {
                        //   this.onChange(removeArray[i], false);
                        // }
                        setTimeout(() => {
                         
                            this.toastrService.clear();
                            this.toastrService.success('Selected  Card deleted successfully');
                          
                      
                          if (this.testStepdata['teststepList']) {
                            removeArray = [];
                            this.testStep = [];
                            this.testStep = this.testStepdata.teststepList;
                            this.testStep = this.testStepdata.teststepList;
                            for (let i = 0; i < this.testStep.length; i++) {

                              this.testStep[i].stepIndex = i;
                              this.testStep[i].viewS = true;
                              // ////this.testStep);
                            }
                            this.visibleIndexForCardTip = this.testStep.length
                            // this.loadFlowchart(this.testStep);
                            this.loadTestStepData = false;
                            // this.getIncludedTestCases();
                          }
                          else {
                            this.testStepCopy = [];
                            this.testStep = [];
                            // this.loadFlowchart(this.testStep);
                          }
                          this.testCase.shareTestSteps(this.testStep);
                        }, 100);



                      }
                    )
                  //  this.testStepdata=data;
                  //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
                }
              });
          }
        });
    }


  }

  skipSelectedRows() {
    var selectedStepIndex = []
    this.selectedSteps.forEach(element => {
      selectedStepIndex.push(element.stepIndex)
    });
    this.selectedIndexArray1 = selectedStepIndex
    if (this.selectedIndexArray1 === undefined) {
      
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to skip/unskip');
  
    
      return;

    }

    if (this.selectedIndexArray1.length < 1) {
     
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to skip/unskip');
      
      return;
    }
    let removeArray = this.selectedIndexArray1;

    removeArray = removeArray.sort((a, b) => a - b)

    for (let i = 0; i < removeArray.length; i++) {
      var temp;
      removeArray[i];
      temp = removeArray[i];

      if (this.testStep[temp].active == 'DISABLE') {
        this.testStep[temp].active = 'ENABLE';
        //// this.testStep[temp])
      }
      else {
        this.testStep[temp].active = 'DISABLE';
        //// this.testStep[temp]);
      }
    }
    ////this.testStepdata);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
    subscribe((data) => {
      if (data) {
        // ////"upDateData", data);
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {
              this.testCase.setSelectedData([]);
              this.dropDataService.selectAllSteps.next(false);
              // sessionStorage.clear();
              // localStorage.clear();
              this.testStepdata = data;
              this.testCaseType = this.testStepdata.testCaseType
              // this.indexFormArray = undefined
              // for (let i = 0; i < removeArray.length; i++) {
              //   this.onChange(removeArray[i], false);
              // }
              this.testCase.setSelectedData([]);
              this.dropDataService.selectAllSteps.next(false);
              setTimeout(() => {
               
                  this.toastrService.clear();
                  this.toastrService.success('Selected  Card Skipped/Unskipped successfully');
                
            
                if (this.testStepdata['teststepList']) {
                  removeArray = [];
                  this.testStep = [];
                  this.testStep = this.testStepdata.teststepList;
                  this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    // ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  // this.loadFlowchart(this.testStep);
                  this.loadTestStepData = false;
                  // this.getIncludedTestCases();
                }
                else {
                  this.testStepCopy = [];
                  this.testStep = [];
                  // this.loadFlowchart(this.testStep);
                }
                this.testCase.shareTestSteps(this.testStep);
              }, 100);



            }
          )
        //  this.testStepdata=data;
        //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
      }
    });
  }
  cutTestSteps(source) {

    var selectedStepIndex = []
    this.selectedSteps.forEach(element => {
      selectedStepIndex.push(element.stepIndex)
    });
    this.selectedIndexArray2 = selectedStepIndex
    if (this.selectedIndexArray2 === undefined) {
     
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to cut');
     
      return;
    }
    else if (this.selectedIndexArray2.length < 1) {
     
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to cut');
   
      return;
    }
    this.cutTestStepArray = {
      list:
        this.selectedIndexArray2
    }

    localStorage.setItem('cutTestStepData', JSON.stringify(this.cutTestStepArray));
    localStorage.setItem('sourceId', source);
    this.testCase.setCutEnable(true);
    this.testCase.setCopyEnable(false);
    
    // ////this.cutTestStepArray)
    // this.enableCutPaste = true;
    // this.enablePaste = false;
    // this.enableCopyCheck = false;
    this.toastrService.clear();
    this.toastrService.success('Selected step cut successfully')
  }
  copySelectedTestStep() {

    var selectedStepIndex = []
    this.selectedSteps.forEach(element => {
      selectedStepIndex.push(element.stepIndex)
    });
    this.selectedIndexArray3 = selectedStepIndex
    if (this.selectedIndexArray3 === undefined) {

     
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to copy');
    

      ////'udefined',this.indexFormArray);

      return;
    }
    else if (this.selectedIndexArray3.length < 1) {
      ////'empty',this.indexFormArray.value);
    
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to copy');
      
      return;
    }
    this.testStepArray = {
      id: JSON.parse(JSON.stringify(this.testStepId)),
      teststepList: []
    };
    // this.enablePaste = true;
    // this.enableCopyCheck = true;
    // this.enableCutPaste = false;
    for (let i = 0; i < this.selectedIndexArray3.length; i++) {
      this.testStepArray.teststepList.push(this.testStep[this.selectedIndexArray3[i]]);
    }
    ////this.testStepArray.teststepList);

    localStorage.setItem('copiedTestStep', JSON.stringify(this.testStepArray));
    this.testCase.setCutEnable(false);
    this.testCase.setCopyEnable(true);

    this.toastrService.clear();
    this.toastrService.success('Selected step copied successfully')
  }
  saveState() {
    // this.projectId;
    const updateTestStepData = this.testStepdata;
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
    ////myFinalObject);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/true', myFinalObject).
      subscribe((data) => {
        if (data) {
          ////'save state',data);
          this.toastrService.success('Step Updated successfully');
        }
      });
  }
  redoUndoAction(action) {
    // this.router = this.router.url;
    this.route.paramMap.subscribe(
      params => {
        ////'params', params); 
        if (action === 'undo') {
          this.http.get(this.url + '/HuLoopRest/huloop/test/redoUndoAction' + '/' + params.get('pid') + '/' + params.get('tid') + '/' + params.get('tsid') + '/undo').
            subscribe(undo => {
              if (undo) {
                // this.getInitTestSteptData();
                // alert(undo);
                this.testCase.setSelectedData([]);
                this.dropDataService.selectAllSteps.next(false);
                console.log('undo',undo);
                
                this.testStepdata = undo;
                if (this.testStepdata.teststepList) {
                 this.testStep = [];
                 this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  // this.loadFlowchart(this.testStep);
                  ////'redo data', this.testStepdata);
                  // alert(redo);
                 
                  this.testCase.shareTestSteps(this.testStep);
                  this.toastrService.clear();
                  this.toastrService.success('Action performed successfully');
                  this.stepOptions=undefined;
                }
                else {
                  this.testStep = [];
                  // this.loadFlowchart(this.testStep);
                  
                  this.testCase.shareTestSteps(this.testStep);
                  this.stepOptions=undefined;
                }
              }
              else {
                this.toastrService.clear();
                this.toastrService.info('No data is avaialble');
              }
            })
        } else {
          this.http.get(this.url + '/HuLoopRest/huloop/test/redoUndoAction' + '/' + params.get('pid') + '/' + params.get('tid') + '/' + params.get('tsid') + '/redo').
            subscribe(redo => {
              if (redo) {
                this.testCase.setSelectedData([]);
                this.dropDataService.selectAllSteps.next(false);
                this.testStepdata = redo;
                console.log(this.testStepdata);
                if (this.testStepdata.teststepList) {
                  this.testStep = [];
                    this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  this.testCase.shareTestSteps(this.testStep);
                  // this.loadFlowchart(this.testStep);
                  ////'redo data', this.testStepdata);
                  // alert(redo);
                  this.toastrService.clear();
                  this.toastrService.success('Action performed successfully');
                  this.stepOptions=undefined;
                }
                else {
                  this.testStep = [];
                  // this.loadFlowchart(this.testStep);
                  this.testCase.shareTestSteps(this.testStep);
                  this.stepOptions=undefined;
                }
              }
              else {
                this.toastrService.clear();
                this.toastrService.info('No data is avaialble');
              }

            })
        }
      })
  }
  encrypParameter(stepIndex) {
    var encryptObj = {
      projectId: this.projectId,
      id: this.testStepId,
      stepIndex: stepIndex-1
    }
    this.testCase.encryptTestStepParam(this.projectId, this.testStepId, stepIndex, encryptObj).subscribe(
      (data) => {
        console.log("Test123 : ", data);
        this.testStepdata = data;
        this.testCaseType = this.testStepdata.testCaseType
        this.toastrService.clear();
        this.toastrService.success('Parameter encrypted successfully')

        if (this.testStepdata['teststepList']) {
          this.testStep = this.testStepdata['teststepList']
          for (let i = 0; i < this.testStep.length; i++) {

            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;
            ////this.testStep);
          }
          this.visibleIndexForCardTip = this.testStep.length
          this.editEnable(this.testStep[stepIndex])
          // this.loadFlowchart(this.testStep);
          this.testCase.shareTestSteps(this.testStep);
          this.loadTestStepData = false;
          this.getIncludedTestCases();

        }
        else {
          this.testStepCopy = [];
        }
      }
    )
  }
  decrypParameter(stepIndex) {
    var encryptObj = {
      projectId: this.projectId,
      id: this.testStepId,
      stepIndex: stepIndex-1
    }
    this.testCase.decryptTestStepParam(this.projectId, this.testStepId, stepIndex, encryptObj).subscribe(
      (data) => {
        console.log("Test123 : ", data);
        this.testStepdata = data;
        this.testCaseType = this.testStepdata.testCaseType
        this.toastrService.clear();
        this.toastrService.success('Parameter decrypted successfully')
        if (this.testStepdata['teststepList']) {
          this.testStep = this.testStepdata['teststepList']
          for (let i = 0; i < this.testStep.length; i++) {

            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;
            ////this.testStep);
          }
          this.visibleIndexForCardTip = this.testStep.length
          this.editEnable(this.testStep[stepIndex])
          // this.loadFlowchart(this.testStep);
          this.testCase.shareTestSteps(this.testStep);
          this.loadTestStepData = false;
          this.getIncludedTestCases();

        }
        else {
          this.testStepCopy = [];
        }
      }
    )
  }
  insertComment(stepIndex,stepData) {
    this.branchActivated=undefined;
    this.testStepIndexForInsert = stepIndex;
    this.stepIndexForInsertComment = this.testStep[stepIndex];
    this.typeCheck = this.stepIndexForInsertComment.type;
    if(stepData.parentId){
      this.branchActivated = stepData.parentId;
      this.valueForUpdate = stepData.stepComment
      return;
    }
    this.valueForUpdate = this.stepIndexForInsertComment.comment;
  }
  @ViewChild('cancelmodalforcomment', null) cancelmodalforcomment: ElementRef;
  onSubmit(insertCommentForm) {

    this.formObj = insertCommentForm.value;
    this.stepIndexForInsertComment.comment = Object.values(this.formObj)[0];
    ////this.stepIndexForInsertComment);
    ////this.testStep);
    if(this.branchActivated){
      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.branchActivated).
          subscribe(
            (data) => {

              this.testStepdata1 = data;
              this.testStep = this.testStepdata1.teststepList;
           
        ////this.testStep);
        // this.testStepdata1.teststepList[i]=this.testStep[i]
      this.testStepdata1.teststepList[this.testStepIndexForInsert].comment=this.stepIndexForInsertComment.comment
    this.testCase.editTestCase(this.projectId, this.testId, this.testStepdata1).subscribe(
      (data) => {
        ////data);
        console.log("Test123 : ", data);
        this.testStepdata = data;
        this.testCaseType = this.testStepdata.testCaseType
        this.cancelmodalforcomment.nativeElement.click();
        this.toastrService.clear();
        this.toastrService.success('comment added successfully');
        insertCommentForm.reset();
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {
              this.testStepdata = data;
              this.testCaseType = this.testStepdata.testCaseType
              this.testStep = this.testStepdata.teststepList;

              for (let i = 0; i < this.testStep.length; i++) {
            
                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;
             
              }
              
              this.stepOptions=undefined
              this.branchActivated=undefined
              this.testCase.shareTestSteps(this.testStep);
              this.visibleIndexForCardTip = this.testStep.length
                // this.loadFlowchart(this.testStep);
            }
          )

      }
    )
  })
    return;
    }
    if(this.projectId!='rc'){
    this.testStepdata.teststepList[this.testStepIndexForInsert].comment=this.stepIndexForInsertComment.comment
    this.testCase.editTestCase(this.projectId, this.testId, this.testStepdata).subscribe(
      (data) => {
        console.log("Test123 : ", data);
        ////data);
        // this.testStepdata = data;
        this.cancelmodalforcomment.nativeElement.click();
        this.toastrService.clear();
        this.toastrService.success('comment added successfully');
        insertCommentForm.reset();
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {
              this.testStepdata = data;
              this.testCaseType = this.testStepdata.testCaseType
              this.testStep = this.testStepdata.teststepList;

              for (let i = 0; i < this.testStep.length; i++) {
                // this.testStep[i] = {
                //    stepIndex:''

                //   }
                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;
                ////this.testStep);
                this.branchActivated=undefined
                ////this.testStep);
                
                // this.loadTestStepData = false;
                // this.getIncludedTestCases();

              }
              this.testCase.shareTestSteps(this.testStep);
              // this.visibleIndexForCardTip = this.testStep.length
                // this.loadFlowchart(this.testStep);
            }
          )

      }
    )
  }
  else{
    this.testStep[this.testStepIndexForInsert].comment=this.stepIndexForInsertComment.comment
    this.updateRc(this.currentRcForUpdate.children.componentName,this.currentRcForUpdate.children.accessType,this.rcCat,this.testStep,this.rcId)
    this.cancelmodalforcomment.nativeElement.click();
    // this.toastrService.clear();
    // this.toastrService.success('comment added successfully');
   
  }
  }
  enableSubmitBUtton(value) {
    if (this.valueForUpdate != value) {
      this.enableBUtton = false;

    }
    else {
      this.enableBUtton = true;
    }
  }
  toggleManual(i,stepData?:any) {
    console.log(stepData);
    if(stepData.parentId)
      {
       
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + stepData.parentId).
          subscribe(
            (data) => {

              this.testStepdata1 = data;
              this.testStep = this.testStepdata1.teststepList;
              if (this.testStep[i].type == 'MANUAL') {
                this.testStep[i].type = 'AUTOMATIC';
              }
              else {
                this.testStep[i].type = 'MANUAL';
              }
        ////this.testStep);
        this.testStepdata1.teststepList[i]=this.testStep[i]
        this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata1).
          subscribe((data) => {
            if (data) {
              // ////"upDateData", data);
              this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                subscribe(
                  (data) => {
                    this.testStepdata = data;
                    this.testCaseType = this.testStepdata.testCaseType
                    this.testStep = this.testStepdata.teststepList;
    
                    for (let i = 0; i < this.testStep.length; i++) {
    
                      this.testStep[i].stepIndex = i;
                      this.testStep[i].viewS = true;
                      ////this.testStep);
                    }
                    this.visibleIndexForCardTip = this.testStep.length
                    // this.loadFlowchart(this.testStep);
                    this.testCase.shareTestSteps(this.testStep);
                    // this.editEnable(this.testStep[i])
                    this.loadTestStepData = false;
                    this.getIncludedTestCases();
                    this.toastrService.clear();
                    this.stepOptions=undefined
                    this.toastrService.success(' changed Manual/Automatic successfully');
    
                  }
                )
              //  this.testStepdata=data;
              //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
            }
          });
        })
        return;
      }

    ////this.testStep[i])
    // if(!this.enableEdit && this.cardView){
    //   this.toastrService.clear();
    //   this.toastrService.warning('Toggle not allowed, Cancel Edit Form then try to perform any Action');
    //   return;
    // }
    
    if (this.testStep[i].type == 'MANUAL') {
      this.testStep[i].type = 'AUTOMATIC';
    }
    else {
      this.testStep[i].type = 'MANUAL';
    }
    ////this.testStep);
    this.testStepdata.teststepList[i]=this.testStep[i]
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
      subscribe((data) => {
        if (data) {
          // ////"upDateData", data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.testStepdata = data;
                this.testCaseType = this.testStepdata.testCaseType
                this.testStep = this.testStepdata.teststepList;

                for (let i = 0; i < this.testStep.length; i++) {

                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
                  ////this.testStep);
                }
                this.visibleIndexForCardTip = this.testStep.length
                // this.loadFlowchart(this.testStep);
                this.testCase.shareTestSteps(this.testStep);
                this.editEnable(this.testStep[i])
                this.loadTestStepData = false;
                this.getIncludedTestCases();
                this.toastrService.clear();
                this.toastrService.success(' changed Manual/Automatic successfully');

              }
            )
          //  this.testStepdata=data;
          //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
        }
      });
  }

  toggleAutomatic(i) {
    ////i);
    this.testStep[i].type = 'AUTOMATIC'

    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
      subscribe((data) => {
        if (data) {
          // ////"upDateData", data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.testStepdata = data;
                this.testCaseType = this.testStepdata.testCaseType
                this.testStep = this.testStepdata.teststepList;

                for (let i = 0; i < this.testStep.length; i++) {

                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
                  ////this.testStep);
                }
                this.visibleIndexForCardTip = this.testStep.length
                // this.loadFlowchart(this.testStep);
                this.testCase.shareTestSteps(this.testStep);
                this.loadTestStepData = false;
                this.getIncludedTestCases();
                this.toastrService.clear();
                this.toastrService.success(' changed Manual/Automatic successfully');

              }
            )

        }
      });
  }

  
  selectAll(event) {

    // this.checkboxes.forEach((element) => {
    //   element.nativeElement.click();
    //   // this.checked_true=true;
    //   // this.checked_master=true;
    // });

    this.selectedSteps = [];
    // this.testCase.setSelectedData(this.selectedSteps); 

    this.dropDataService.selectAllSteps.next(event);

    if(event && this.testStepdata.teststepList)
    {
      this.testStepdata.teststepList.forEach((element, i) => {
        if(element.commandName != 'HITL')
        {
          this.selectedSteps.push(element)
        }
      });
    }
    else{
      this.testCase.setSelectedData(this.selectedSteps); 
      return;
    }
    
    this.testCase.setSelectedData(this.selectedSteps); 

    this.checkAllTestSteps = event;

      this.testStepCopy.forEach(element => {
        element.checked = event;
        this.onChange(element.stepIndex, event);
      });
    
  }
  onChange(index: any, isChecked: boolean) {
    this.checkedIndex=index

  let isAllTestCasesChecked = true;

  

  this.checkAllTestSteps = isAllTestCasesChecked;

  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;
  this.enableCopy = true;
  this.enableCut = true;
  if (isChecked) {

    this.indexFormArray.push(new UntypedFormControl(index));
    ////this.indexFormArray.value);
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == index)
    this.indexFormArray.removeAt(Index);
    if (this.indexFormArray.value.length < 1) {
      this.enableCopy = false;
      this.enablePaste = false;
      this.enableCut = false;
    }
   
    
}
console.log(this.indexFormArray); 
}
stopDrag(e){
  this.toastrService.clear();
  this.toastrService.warning('You cannot drag group')
  e.preventDefault();
}

changeDefaultView(data) {
  this.userManagement.updateDefaultView(data).subscribe((res) => {
    this.toastrService.clear();
    this.toastrService.success("Default view updated successfully");
    localStorage.removeItem('currentUser')
    this.userService.getUser().subscribe((res: any) => {
      
      localStorage.setItem('currentUser', JSON.stringify(res));
      this.cardView = res.isCardView == 'true' ? true : false;
      // this.testCase.setView(this.cardView);
      this.desableCardView()
    })
    
  
  })
}

newRequest = this.testCase.getRecordingStatus();

getRecordingStatus() {
  return this.testCase.getRecordingStatus();
}

tabList = [];
checkExtension = 0;

inputBaseURL() {
    this.tabList = [];
    this.testCase.setEventData(undefined);
    this.testCase.setCopyStatus("NO");
    this.testCase.setRecordMode(null);
    this.newRequest = true;
    var count = 2;
    for (let index = 0; index < 2; index++) {
      window.postMessage({
        type: "CHECK_IF_EXTENSION_INSTALLED"
      }, "*");
  
    }
   
      window.addEventListener("message", (event) => {
        if (event.data.type && event.data.type === "FROM_IF_EXTENSION_INSTALLED") {
          if (event.data.actions && event.data.actions === "version") {
            this.tabList = event.data.tabs;
            console.log('tablist',this.tabList);
            
            this.checkExtension = 2;
            ////"Receiving response and changing value");
          }
        } else if (event.data.type && event.data.type === "CHECK_IF_EXTENSION_INSTALLED") {
          this.checkExtension = 1;
        }
      });


    setTimeout(() => {
      if (this.checkExtension === 2) {
        // Flow chart does not implement Mouse Sequence insert; keep Record Steps only.
        this.confirmationDialogService.openRecordDialog('Record', this.tabList, undefined, { showMouseSequence: false }).afterClosed().subscribe(
          (res) => {
            if (!res) {
              this.testCase.setRecordMode(null);
            }
          }
        )
      } else if (this.checkExtension === 1) {
        ////this.checkExtension); 
        this.testCase.setRecordMode(null);
        this.toastrService.info("Please refresh the browser (Ctrl+Shift+R) and try again if recorder is already loaded.");
      }
    }, 500);

  }


stopRecording() {
  if (this.newRequest) {
    this.testCase.setEventData(undefined);
    this.testCase.setRecordingStatus(false);

    if (this.testStep == undefined) {
      this.testStep = [];
    }
    if (this.testStep.length > 0) {
      this.confirmationDialogService.stopRecordconfirmationDialog('Do you want to overwrite the whole script or create a new copy?').afterClosed().subscribe(
        (res) => {
          if (res) {
            this.testCase.setCopyStatus("YES");
            this.createRecordedData();
            this.closeRecordedPage();
          }
          else if (res == false) {
            ////'responce', res);
            this.testCase.setCopyStatus("NO");

            this.createRecordedData();
            this.closeRecordedPage();


            ////'copy');
          }
          else {
            this.closeRecordedPage();
          }
        }
      )


    }
    else {
      this.testCase.setCopyStatus("NO");
      this.createRecordedData();

      this.closeRecordedPage();
    }
    this.newRequest = false;
  }
};
closeRecordedPage() {
  window.postMessage({
    type: "FROM_STOP_RECORD_PAGE_ONLY"
  }, "*");
}

createRecordedData() {
  var flag = false;
  ////"Web Page Send Stop Record Page Request");
  window.postMessage({
    type: "FROM_STOP_RECORD_PAGE"
  }, "*");

  window.addEventListener("message", (event) => {
    // if (dismissRecordingModel === 'dismiss') {
    //     return;
    // }
    // dismissRecordingModel = 'close';
    if (event.source !== window) {
      return;
    }
    else if (event.data.type && (event.data.type === "FROM_STOP_RECORD_PAGE_RESP")) {
      flag = false;

      var recordCommands = {};
      if (JSON.stringify(this.testCase.getEventData()) !== JSON.stringify(event.data)) {

        this.testCase.setEventData(JSON.parse(JSON.stringify(event.data)));
        ////event.data);

        flag = true;
        recordCommands['recordCommand'] = event.data.actions;
        var baseUrl = this.testCase.getRecordingUrl();
        var openCmd = "open";
        var eventCmd = "open";
        if (this.projectType === 'MIXED') {
          openCmd = "openBrowser";
          eventCmd = "openBrowser";
        }
        var openingCommand = {
          "actionType": openCmd,
          "eventName": eventCmd, "tagType": "NA",
          "type": "NA", "formAttrs": { "ID": "reg" },
          "tagAttrs": { "NAME": "browser" }, "tagContent": "f",
          "cssSelector": "#u_0_a", "tagPos": 0, "xpath": baseUrl
        };
        var filterCommands = {};
        filterCommands['recordCommand'] = new Array();
        var isFrame = false;
        var frameIndex = 0;
        var size = screen.width + "," + screen.height;
        filterCommands['recordCommand'].push(openingCommand);
        ////filterCommands);

        if (recordCommands['recordCommand']) {
          for (var i = 0; i < recordCommands['recordCommand'].length; i++) {

            if (isFrame && (frameIndex === (i - 1))) {
              isFrame = false;
              filterCommands['recordCommand'][frameIndex + 1].xpath = recordCommands['recordCommand'][i].xpath;
              filterCommands['recordCommand'][frameIndex + 1].tagAttrs = recordCommands['recordCommand'][i].tagAttrs;
            }
            var command = {
              "actionType": recordCommands['recordCommand'][i].actionType,
              "eventName": recordCommands['recordCommand'][i].eventName,
              "tagName": recordCommands['recordCommand'][i].tagName,
              "tagType": recordCommands['recordCommand'][i].tagType,
              "type": recordCommands['recordCommand'][i].type,
              "formAttrs": recordCommands['recordCommand'][i].formAttrs,
              "tagAttrs": recordCommands['recordCommand'][i].tagAttrs,
              "cssSelector": recordCommands['recordCommand'][i].cssSelector,
              "tagPos": recordCommands['recordCommand'][i].tagPos,
              "xpath": recordCommands['recordCommand'][i].xpath,
              "tagContent": recordCommands['recordCommand'][i].tagContent,
              "xClient": recordCommands['recordCommand'][i].xClient,
              "yClient": recordCommands['recordCommand'][i].yClient,
              "screenSize": size
            };
            // filterCommands.recordCommand.push(command);
            filterCommands['recordCommand'].push(recordCommands['recordCommand'][i]);
            if ("Frame" === command.actionType || "selectwindow" === command.actionType) {
              // Use the Locator of the next step for this one
              isFrame = true;
              frameIndex = i;
              ////'filterCommands',filterCommands);

            }

          }

        }
        if (flag) {
          ////this.testIdForRecoder);
          var recordData = localStorage.getItem('testForRecoder');
          var projectIdForRecorder = localStorage.getItem('projectIdForRecoder');
          var taskIdForRecorder = localStorage.getItem('taskIdForRecorder');
          this.testCase.saveRecordData(projectIdForRecorder, taskIdForRecorder, recordData, filterCommands, this.testCase.getCopyStatus()).toPromise().then(
            (res) => {
              ////res);

              if (this.testCase.getCopyStatus() == 'NO') {

                this.projectId = projectIdForRecorder;
                this.testId = taskIdForRecorder;
                this.testStepId = recordData;
                this.testStepCopy = []
                // setTimeout(() => {
                // this.reloadComponent();
                this.toastrService.clear();
                this.toastrService.success('Case is created successfully');
                // }, 1000);
            this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                subscribe(
           (data) => {
            this.testStepdata = data;
            this.testCaseType = this.testStepdata.testCaseType
            if (this.testStepdata && this.testStepdata['teststepList']) {
              this.testStep = this.testStepdata.teststepList;
              for (let i = 0; i < this.testStep.length; i++) {

                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;

              }
              setTimeout(() => {
              this.toastrService.clear();
              this.toastrService.success('Case is created successfully');
              // this.testCase.shareTestSteps(this.testStep);
              this.closeRecordedPage();
              this.reloadComponent();
              }, 1500);
              
              }
            })
              if (this.testCase.getCopyStatus() == 'YES') {

                this.toastrService.clear();
                this.toastrService.success('Case copy created successfully with recorded steps');
                this.closeRecordedPage();
              }




              //'Test Case copy created successfully with recorded steps'
            }
            else{
              this.toastrService.clear();
              this.toastrService.success('Case is created successfully');
            }
          }
          );


        }

      }
    }
  });

}

reloadComponent() {
  let currentUrl = this.router.url;
  this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  this.router.onSameUrlNavigation = 'reload';
  this.router.navigate([currentUrl]);
}
desableCardView() {
  // localStorage.removeItem('currentUser')
  this.router.navigate(['/test/TestStep/' + this.projectId + '/' + this.testId + '/' + this.testStepId]);
  
}
loadUser() {
  // this.userService.getUser().subscribe((res: any)=>{
  //   this.cardView = res.isCardView == 'true' ? true : false;
  //   localStorage.setItem('currentUser', JSON.stringify(res));
  //   this.testCase.setView(this.cardView);
  // })

  {
    if (!JSON.parse(localStorage.getItem('currentUser'))) {
      this.userService.getUser().subscribe((res: any) => {
        localStorage.setItem("currentUser", JSON.stringify(res));
        this.cardView = res.isCardView == 'true' ? true : false;
       
        // this.testCase.setView(this.cardView);
      
      })
    }
    else {
      var resp = JSON.parse(localStorage.getItem('currentUser'));
      this.cardView = resp.isCardView == 'true' ? true : false;
      this.testCase.setView(this.cardView);
    }

  }
}

getRC()
{
  // this.subscription4 =  this.testCase.getTestSteps().subscribe((res: any) => {
  //   console.log("Test123 : ", res);
  //   this.currentTestSteps = res
  //   let flowchartView = { "root": this.convertTableToFlowchart(res), "connectors": [] };
  //     this.sampleJson = flowchartView;
  //     this.showUpload();
  // })
  this.project.getRC().subscribe((res: any) => {
    if (res) {
      console.log('obj',res);
      
      this.rcResponse = res;
      let keys = Object.keys(this.rcResponse);
      let list = [];
      keys.forEach((key) => {
        let obj = { type: 'category', name: key, children: [] }
        let rcKeys = Object.keys(this.rcResponse[key]);
        rcKeys.forEach((rcKey) => {
          let rcObj = { type: 'rc', name: rcKey, children: this.rcResponse[key][rcKey] };
          obj.children.push(rcObj);
        })
        list.push(obj);
      })
      this.rcCategoryList = list;
      this.rcCategoryList.forEach(element => {
        element.children.forEach(childElement => {
          childElement.name = childElement.children.componentName
        });
      });
      if(this.projectId=='rc'){
        this.currentRcCat = this.rcCategoryList.find((f:any)=>f.name==this.rcCat);
        var currentRc = this.currentRcCat.children.find((f:any)=>f.children.id==this.rcId)
        this.currentRcForUpdate = currentRc;
        console.log('obj',this.currentRcForUpdate);
        
        this.testStep = currentRc.children.testSteps
        localStorage.setItem('rcDetails',JSON.stringify(this.currentRcForUpdate))
        localStorage.setItem('allRcSteps',JSON.stringify(this.testStep))
        for (let i = 0; i < this.testStep.length; i++) {

          this.testStep[i].stepIndex = i;
          this.testStep[i].viewS = true;

        }
        let flowchartView = { "root": this.convertTableToFlowchart(this.testStep), "connectors": [] };
        this.sampleJson = flowchartView;
        console.log('sample',this.sampleJson);
        
        this.showUpload();
        
      }
      // if(this.projectId=='rc'){
        
      // }
    }
  });
}

createRc()
{
  console.log(this.createRCForm.value);
  let obj;
  // this.selectedSteps.forEach(element => {
  //   if(element['stepComment']){
  //     element['comment'] = element['stepComment']
  //   }
  // });
  if(this.projectId!='rc'){
     obj = {
      "componentName": this.createRCForm.value.componentName,
      "accessType": this.createRCForm.value.componentType,
      "category": this.createRCForm.value.category,
      "testSteps": this.selectedSteps,
      "projectId":this.projectId
    }
    
  }
  if(this.projectId=='rc'){
    obj =  {
    "componentName": this.createRCForm.value.componentName,
      "accessType": this.createRCForm.value.componentType,
      "category": this.createRCForm.value.category,
      "testSteps": this.selectedSteps,
      "projectId":''
    }
  }
  
  console.log("obj : ", obj);
  this.project.createRC(obj).subscribe((res)=>
  {
    this.selectedSteps = []
    this.testCase.setSelectedData(this.selectedSteps);
    this.toastrService.clear();
    this.toastrService.success("Reusable component created");

    this.cancelCreateRC.nativeElement.click();
     
    this.getRC();
  })

}
updateRc(componentName,accessType,cat,testSteps,id){
  let obj = {
    "id":id,
    "componentName": componentName,
    "accessType": accessType,
    "category": cat,
    "testSteps": testSteps
  }
  console.log("obj : ", obj);
  this.project.updateRC(obj).subscribe((res:any)=>
  {
    this.toastrService.clear();
    this.toastrService.success("Reusable component updated successfully");
    this.cancelCreateRC.nativeElement.click();
    this.testStep = res.testSteps
    // localStorage.setItem('rcDetails',JSON.stringify(this.currentRcForUpdate))
    // localStorage.setItem('allRcSteps',JSON.stringify(this.testStep))
    for (let i = 0; i < this.testStep.length; i++) {

      this.testStep[i].stepIndex = i;
      this.testStep[i].viewS = true;

    }
    localStorage.setItem('allRcSteps',JSON.stringify(this.testStep))
    let flowchartView = { "root": this.convertTableToFlowchart(this.testStep), "connectors": [] };
        this.sampleJson = flowchartView;
        console.log('sample',this.sampleJson);
        
        this.showUpload();
        // this.getRC()
  })

}

clearCategory()
{
  this.createRCForm.get('category')?.setValue('');
}

openCreateRCModal()
{
  if(this.selectedSteps?.length == 0 || this.selectedSteps==undefined)
  {
    this.toastrService.clear();
    this.toastrService.warning("Select atleast one step to create Reusable component");
    return;
  }
  this.initAllForms();
  const modalElement = document.getElementById('create-rc');
  if (modalElement) {
    const modalInstance = new bootstrap.Modal(modalElement);
    modalInstance.show();
  }
}

ngOnDestroy() {
  // this.subscription.unsubscribe();
  // this.subscription1.unsubscribe();
  this.testCase.shareTestSteps(undefined);
  this.dropDataService.selectAllSteps.next(false);
  this.testCase.setSelectedData([]);
  this.checkAllTestSteps = false;
  this.stepOptions = undefined;
  // this.subscription3.unsubscribe();
}

rcResponse = {
  "TestCategory": {
      "TestComponent": [
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "",
              "parameters": {
                  "settingValue": "http://agreeya.com/Emp_Referral.aspx",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "wait_short",
              "parameters": {
                  "settingValue": "",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "5",
              "parameters": {
                  "settingValue": "55",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "Agreeya_Screen",
              "elementKey": "Candidate name",
              "parameters": {
                  "settingValue": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "",
              "parameters": {
                  "settingValue": "",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "Agreeya_Screen",
              "elementKey": "Candidate name",
              "parameters": {
                  "settingValue": "else if block",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "5",
              "parameters": {
                  "settingValue": "7",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "Agreeya_Screen",
              "elementKey": "Candidate name",
              "parameters": {
                  "settingValue": "else if block",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "",
              "parameters": {
                  "settingValue": "",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "Agreeya_Screen",
              "elementKey": "Candidate name",
              "parameters": {
                  "settingValue": "BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "",
              "parameters": {
                  "settingValue": "",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "wait_short",
              "parameters": {
                  "settingValue": "",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "Agreeya_Screen",
              "elementKey": "Candidate name",
              "parameters": {
                  "settingValue": "var",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          },
          {
              "runState": "AC",
              "name": "OPENBROWSER",
              "pageName": "",
              "elementKey": "2000",
              "parameters": {
                  "settingValue": "",
                  "isMasked": false,
                  "owner": "",
                  "settingType": "STANDARD",
                  "fieldType": "",
                  "values": []
              },
              "testData": "",
              "stepComment": "",
              "maskedData": "",
              "runtimeData": false,
              "type": "AUTOMATIC",
              "debug": "NONE",
              "testStepResult": {
                  "startTime": 0,
                  "endTime": 0,
                  "duration": 0.0,
                  "auditInfoS": [],
                  "resultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "aggrResultState": {
                      "status": "NOTRUN",
                      "passCount": 0,
                      "failCount": 0,
                      "incolusiveCount": 0,
                      "notRunCount": 1,
                      "modifiedCount": 0,
                      "skippedCount": 0,
                      "blockedCount": 0,
                      "totalCount": 1
                  },
                  "screenshotWeb": false
              },
              "active": "ENABLE",
              "evaluatedMetaValue": "false",
              "hitlDialog": false
          }
      ]
  },
  "Test" :
  {
    "t1" : [],
    "t2" : [],
    "t3" : []
  },
  "Admin": 
  {
    "a1": []
  }
}
// userEmail: string;
groupDetails: any;
extractionTerms: any;
redactionTerms: any;
isER: boolean = false;
extractionTermsCopy: any;
redactionTermsCopy: any;
erUrl: any = "";
cities: any = [];
selectedItems: any = [];

  selectedKeys1 = [];
  selectedKeys2 = [];
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',           // Match this with your data structure
    textField: 'name',       // Match this with your data structure
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
getRedactionDetails() {
  this.userEmail = JSON.parse(localStorage.getItem('currentUser')).email;
  
  // Add error handling for localStorage
  if (!this.userEmail) {
    console.error('No user email found in localStorage');
    return;
  }

  this.redactionService.getRedactionFilters(this.erUrl, this.userEmail)
    .subscribe({
      next: (res) => {
        console.log('Response received:', res); // Debug log 1
        
        try {
          this.groupDetails = res;

          let extractionDetails = res['data']['Extraction'];
          let redactionDetails = res['data']['Redaction'];

          console.log('Extraction details:', extractionDetails); // Debug log 2
          console.log('Redaction details:', redactionDetails); // Debug log 3

          let extractionGroups: any = [];
          let redactionGroups: any = [];

          let extractionPII = {
            title: 'Personal Identifable Information',
            access: 'public',
            Entities: extractionDetails['Standard PII'],
            shared: []
          };
          extractionGroups.push(extractionPII);
          
          extractionDetails['Groups'].forEach(group => {
            let obj = {
              title: group.title,
              access: group.Access,
              Entities: group.Entities,
              shared: group.Shared
            };
            extractionGroups.push(obj);
          });

          console.log('Extraction groups processed:', extractionGroups); // Debug log 4

          let redactionPII = {
            title: 'Personal Identifable Information',
            access: 'public',
            Entities: redactionDetails['Standard PII'],
            shared: []
          };
          redactionGroups.push(redactionPII);
          
          redactionDetails['Groups'].forEach(group => {
            let obj = {
              title: group.title,
              access: group.Access,
              Entities: group.Entities,
              shared: group.Shared
            };
            redactionGroups.push(obj);
          });

          console.log('Redaction groups processed:', redactionGroups); // Debug log 5

          this.extractionTerms = extractionGroups;
          this.extractionTermsCopy = extractionGroups;
          this.redactionTerms = redactionGroups;
          this.redactionTermsCopy = redactionGroups; // Fixed this line

          console.log("Final values:", {
            extractionTerms: this.extractionTerms,
            redactionTerms: this.redactionTerms
          });

          this.extractionList = ['StandardPII', ...extractionDetails['Groups'].map(group => group.title)];

          // Create redaction list
          this.redactionList = ['StandardPII', ...redactionDetails['Groups'].map(group => group.title)];
          
         
        } catch (error) {
          console.error('Error processing response:', error);
        }
      },
      error: (error) => {
        console.error('Error fetching redaction filters:', error);
      },
      complete: () => {
        console.log('Request completed');
      }
    });
}
onItemSelect1(item: any) {
  // this.selectedKeys=[];
  //console.log('onItemSelect', item);
  this.isER = true;
  this.selectedKeys1.push(item);
  // this.objectForEditTestStep['cus']
  console.log(this.objectForEditTestStep.parameters.settingValue)
  console.log(this.objectForEditTestStep);
  console.log(this.selectedKeys.toString());
  //console.log(this.selectedKeys)
}
onItemDeSelect1(item: any) {
  var index = this.selectedKeys1.indexOf(item);
  if (index !== -1) {
    this.selectedKeys1.splice(index, 1);
  }
  //console.log(item);
  //console.log(this.selectedKeys);
  // this.testStep[this.testStepIndex - 1].parameters.settingValue = this.selectedKeys.toString()
}
}

